export default {
    zh: {
        // 列表页基础UI
        loading: '正在加载',
        pleaseWait: '请稍候...',
        filter: '筛选',
        recommend: '推荐',
        latest: '最新',
        male: '男',
        female: '女',
        recent: '最近',
        
        // 空状态
        noCharactersFound: '未找到角色',
        adjustFilters: '尝试调整筛选条件',
        adjustFiltersSuggestion: '或浏览其他分类',
        resetAll: '重置全部',
        noDescription: '暂无描述',
        
        // 操作
        startChat: '开始聊天',
        chat: '聊天',
        
        // 加载状态
        loadFailed: '加载失败',
        noMoreData: '没有更多了',
        
        // Toast消息
        toast: {
            operationFailed: '操作失败',
        },
        
        // 时间格式化
        time: {
            justNow: '刚刚聊过',
            minutesAgo: '分钟前聊过',
            hoursAgo: '小时前聊过',
            yesterday: '昨天',
        },
        
        // 消息类型
        messageType: {
            image: '[图片]',
            gifAnimation: '[GIF动画]',
            audio: '[语音]',
            touch3d: '[3dtouch]',
            card: '[卡片]',
            tip: '[提示]',
            soul: '[心声]',
            media: '[媒体]',
            mateIntro: '[mate介绍]',
            post: '[动态]',
            novel: '[小说]',
            sceneSwitch: '[场景]',
        },
        
        // 筛选相关
        genderFilter: '性别筛选',
        interestTags: '兴趣标签',
        resetFilter: '重置筛选',
        
        // 聊天列表
        messageList: '消息列表',
        recentChats: '最近聊天',
        noMessages: '暂无消息',
        noChatHistory: '暂无聊天记录',
        noMoments: '暂无动态',
        continue: '继续',
        
        // 详情页tab
        profile: '资料',
        moments: '动态',
        characterIntro: '📝 人物简介',
        characterProfile: '🌟 人设描述',
        characterSetting: '🌟 人设描述',
        personality: '😇 性格',
        backgroundStory: '🏰 背景故事',
        interests: '💖 兴趣爱好',
        likes: '💕 喜欢的事物',
        dislikes: '💔 不喜欢的事物',
        expand: '展开',
        collapse: '收起',
        noIntro: '暂无介绍',
        noMore: '没有更多了',
        
        // Info labels
        gender: '性别',
        age: '年龄',
        height: '身高',
        weight: '体重',
        
        // 标签 - 用于index.vue（tagXXX格式）
        tagAll: 'ALL',
        tagStepRelative: '继亲',
        tagRoommate: '室友',
        tagNeighbor: '邻居',
        tagMarried: '已婚',
        tagEx: '前任',
        tagChildhoodSweetheart: '青梅竹马',
        tagBoss: '上司',
        tagSubordinate: '下属',
        tagTeacherStudent: '师生',
        tagArchEnemy: '死对头',
        tagStranger: '陌生人',
        tagContractPartner: '契约伴侣',
        tagRichFamily: '豪门',
        tagMafia: '黑帮',
        tagDoctor: '医生',
        tagIdol: '偶像',
        tagAssassin: '杀手',
        tagMaid: '女仆',
        tagLandlord: '房东',
        tagYandere: '病娇',
        tagTsundere: '傲娇',
        tagAloof: '高冷',
        tagShy: '害羞',
        tagDominant: '强势',
        tagSubmissive: '顺从',
        tagGentle: '温柔',
        tagAirhead: '天然呆',
        tagStrict: '严厉',
        tagObsessed: '痴迷',
        tagScheming: '腹黑',
        tagPureLove: '纯爱',
        tagMilf: '熟女',
        tagDilf: '熟男',
        tagCurvy: '丰满',
        tagMuscular: '肌肉',
        tagPetite: '娇小',
        tagGothic: '哥特',
        tagHotGirl: '辣妹',
        tagUniform: '制服',
        tagVampire: '吸血鬼',
        tagWerewolf: '狼人',
        tagDemon: '恶魔',
        tagSuccubus: '魅魔',
        tagOrc: '兽人',
        tagMonsterGirl: '魔物娘',
        tagRobot: '机器人',
        tagElf: '精灵',
        tagDoujin: '同人',
        tagAnime: '动漫',
        tagTwoDimensional: '二次元',
        tagWorkplace: '职场',
        tagSchool: '校园',
        tagFantasy: '奇幻',
        tagUrban: '都市',
        tagBlindDate: '相亲',
        tagDark: '暗黑',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALL',
            STEP_RELATIVE: '继亲',
            ROOMMATE: '室友',
            NEIGHBOR: '邻居',
            MARRIED: '已婚',
            EX: '前任',
            CHILDHOOD_SWEETHEART: '青梅竹马',
            BOSS: '上司',
            SUBORDINATE: '下属',
            TEACHER_STUDENT: '师生',
            ARCH_ENEMY: '死对头',
            STRANGER: '陌生人',
            CONTRACT_PARTNER: '契约伴侣',
            RICH_FAMILY: '豪门',
            MAFIA: '黑帮',
            DOCTOR: '医生',
            IDOL: '偶像',
            ASSASSIN: '杀手',
            MAID: '女仆',
            LANDLORD: '房东',
            YANDERE: '病娇',
            TSUNDERE: '傲娇',
            ALOOF: '高冷',
            SHY: '害羞',
            DOMINANT: '强势',
            SUBMISSIVE: '顺从',
            GENTLE: '温柔',
            AIRHEAD: '天然呆',
            STRICT: '严厉',
            OBSESSED: '痴迷',
            SCHEMING: '腹黑',
            PURE_LOVE: '纯爱',
            MILF: '熟女',
            DILF: '熟男',
            CURVY: '丰满',
            MUSCULAR: '肌肉',
            PETITE: '娇小',
            GOTHIC: '哥特',
            HOT_GIRL: '辣妹',
            UNIFORM: '制服',
            VAMPIRE: '吸血鬼',
            WEREWOLF: '狼人',
            DEMON: '恶魔',
            SUCCUBUS: '魅魔',
            ORC: '兽人',
            MONSTER_GIRL: '魔物娘',
            ROBOT: '机器人',
            ELF: '精灵',
            DOUJIN: '同人',
            ANIME: '动漫',
            TWO_DIMENSIONAL: '二次元',
            WORKPLACE: '职场',
            SCHOOL: '校园',
            FANTASY: '奇幻',
            URBAN: '都市',
            BLIND_DATE: '相亲',
            DARK: '暗黑',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    en: {
        // Basic UI for list page
        loading: 'Loading',
        pleaseWait: 'Please wait...',
        filter: 'Filter',
        recommend: 'Recommended',
        latest: 'Latest',
        male: 'Male',
        female: 'Female',
        recent: 'Recent',
        
        // Empty states
        noCharactersFound: 'No Characters Found',
        adjustFilters: 'Try adjusting your filters',
        adjustFiltersSuggestion: 'or browse other categories',
        resetAll: 'Reset All',
        noDescription: 'No Description',
        
        // Actions
        startChat: 'Start Chat',
        chat: 'Chat',
        // Loading states
        loadFailed: 'Load Failed',
        noMoreData: 'No More Data',
        
        // Toast messages
        toast: {
            operationFailed: 'Operation Failed',
        },
        
        // Time formatting
        time: {
            justNow: 'Just now',
            minutesAgo: 'mins ago',
            hoursAgo: 'hrs ago',
            yesterday: 'Yesterday',
        },
        
        // Message types
        messageType: {
            image: '[Image]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Card]',
            tip: '[Tip]',
            soul: '[Soul]',
            media: '[Media]',
            mateIntro: '[Mate Intro]',
            post: '[Post]',
            novel: '[Novel]',
            sceneSwitch: '[Scene]',
        },
        
        // Filter related
        genderFilter: 'Gender',
        interestTags: 'Interests',
        resetFilter: 'Reset Filter',
        
        // Chat list
        messageList: 'Message List',
        recentChats: 'Recent Chats',
        noMessages: 'No Messages',
        noChatHistory: 'No Chat History',
        noMoments: 'No Moments',
        continue: 'Continue',
        
        // Detail page tabs
        profile: 'Profile',
        moments: 'Moments',
        characterIntro: '📝 Character Intro',
        characterProfile: '🌟 Character Profile',
        characterSetting: '🌟 Character Setting',
        personality: '😇 Personality',
        backgroundStory: '🏰 Background Story',
        interests: '💖 Interests',
        likes: '💕 Likes',
        dislikes: '💔 Dislikes',
        expand: 'Expand',
        collapse: 'Collapse',
        noIntro: 'No Introduction',
        noMore: 'No More',
        
        // Info labels
        gender: 'Gender',
        age: 'Age',
        height: 'Height',
        weight: 'Weight',
        
        // Tags - for index.vue (tagXXX format)
        tagAll: 'ALL',
        tagStepRelative: 'Step Relative',
        tagRoommate: 'Roommate',
        tagNeighbor: 'Neighbor',
        tagMarried: 'Married',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Childhood Sweetheart',
        tagBoss: 'Boss',
        tagSubordinate: 'Subordinate',
        tagTeacherStudent: 'Teacher/Student',
        tagArchEnemy: 'Arch Enemy',
        tagStranger: 'Stranger',
        tagContractPartner: 'Contract Partner',
        tagRichFamily: 'Rich Family',
        tagMafia: 'Mafia',
        tagDoctor: 'Doctor',
        tagIdol: 'Idol',
        tagAssassin: 'Assassin',
        tagMaid: 'Maid',
        tagLandlord: 'Landlord',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Aloof',
        tagShy: 'Shy',
        tagDominant: 'Dominant',
        tagSubmissive: 'Submissive',
        tagGentle: 'Gentle',
        tagAirhead: 'Airhead',
        tagStrict: 'Strict',
        tagObsessed: 'Obsessed',
        tagScheming: 'Scheming',
        tagPureLove: 'Pure Love',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Curvy',
        tagMuscular: 'Muscular',
        tagPetite: 'Petite',
        tagGothic: 'Gothic',
        tagHotGirl: 'Hot Girl',
        tagUniform: 'Uniform',
        tagVampire: 'Vampire',
        tagWerewolf: 'Werewolf',
        tagDemon: 'Demon',
        tagSuccubus: 'Succubus',
        tagOrc: 'Orc',
        tagMonsterGirl: 'Monster Girl',
        tagRobot: 'Robot',
        tagElf: 'Elf',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Workplace',
        tagSchool: 'School',
        tagFantasy: 'Fantasy',
        tagUrban: 'Urban',
        tagBlindDate: 'Blind Date',
        tagDark: 'Dark',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALL',
            STEP_RELATIVE: 'Step Relative',
            ROOMMATE: 'Roommate',
            NEIGHBOR: 'Neighbor',
            MARRIED: 'Married',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Childhood Sweetheart',
            BOSS: 'Boss',
            SUBORDINATE: 'Subordinate',
            TEACHER_STUDENT: 'Teacher/Student',
            ARCH_ENEMY: 'Arch Enemy',
            STRANGER: 'Stranger',
            CONTRACT_PARTNER: 'Contract Partner',
            RICH_FAMILY: 'Rich Family',
            MAFIA: 'Mafia',
            DOCTOR: 'Doctor',
            IDOL: 'Idol',
            ASSASSIN: 'Assassin',
            MAID: 'Maid',
            LANDLORD: 'Landlord',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Aloof',
            SHY: 'Shy',
            DOMINANT: 'Dominant',
            SUBMISSIVE: 'Submissive',
            GENTLE: 'Gentle',
            AIRHEAD: 'Airhead',
            STRICT: 'Strict',
            OBSESSED: 'Obsessed',
            SCHEMING: 'Scheming',
            PURE_LOVE: 'Pure Love',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Curvy',
            MUSCULAR: 'Muscular',
            PETITE: 'Petite',
            GOTHIC: 'Gothic',
            HOT_GIRL: 'Hot Girl',
            UNIFORM: 'Uniform',
            VAMPIRE: 'Vampire',
            WEREWOLF: 'Werewolf',
            DEMON: 'Demon',
            SUCCUBUS: 'Succubus',
            ORC: 'Orc',
            MONSTER_GIRL: 'Monster Girl',
            ROBOT: 'Robot',
            ELF: 'Elf',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Workplace',
            SCHOOL: 'School',
            FANTASY: 'Fantasy',
            URBAN: 'Urban',
            BLIND_DATE: 'Blind Date',
            DARK: 'Dark',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    ja: {
        loading: '読み込み中',
        pleaseWait: 'お待ちください...',
        filter: '絞り込み',
        recommend: 'おすすめ',
        latest: '最新',
        male: '男性',
        female: '女性',
        recent: '履歴',
        noCharactersFound: 'キャラクターが見つかりません',
        adjustFilters: 'フィルター条件を調整してください',
        adjustFiltersSuggestion: 'または他のカテゴリーをご覧ください',
        resetAll: 'すべてリセット',
        noDescription: '説明なし',
        startChat: 'チャット開始',
        chat: 'チャット',
        loadFailed: '読み込み失敗',
        noMoreData: 'これ以上ありません',
        toast: {
            operationFailed: '操作が失敗しました',
        },
        time: {
            justNow: 'たった今',
            minutesAgo: '分前',
            hoursAgo: '時間前',
            yesterday: '昨日',
        },
        messageType: {
            image: '[画像]',
            gifAnimation: '[GIF]',
            audio: '[音声]',
            touch3d: '[3Dタッチ]',
            card: '[カード]',
            tip: '[ヒント]',
            soul: '[ソウル]',
            media: '[メディア]',
            mateIntro: '[メイト紹介]',
            post: '[投稿]',
            novel: '[小説]',
            sceneSwitch: '[シーン]',
        },
        genderFilter: '性別',
        interestTags: '特徴タグ',
        resetFilter: 'フィルターをリセット',
        messageList: 'メッセージリスト',
        recentChats: '最近のチャット',
        noMessages: 'メッセージなし',
        noChatHistory: 'チャット履歴なし',
        noMoments: 'モーメントなし',
        continue: '続ける',
        profile: 'プロフィール',
        moments: 'モーメント',
        characterIntro: '📝 キャラクター紹介',
        characterProfile: '🌟 キャラクター設定',
        characterSetting: '🌟 キャラクター設定',
        personality: '😇 性格',
        backgroundStory: '🏰 背景ストーリー',
        interests: '💖 興味',
        likes: '💕 好きなもの',
        dislikes: '💔 嫌いなもの',
        expand: 'もっと見る',
        collapse: '折りたたむ',
        noIntro: '紹介なし',
        noMore: 'これ以上ありません',
        gender: '性別',
        age: '年齢',
        height: '身長',
        weight: '体重',
        tagAll: 'すべて',
        tagStepRelative: '継親',
        tagRoommate: 'ルームメイト',
        tagNeighbor: '隣人',
        tagMarried: '既婚',
        tagEx: '元恋人',
        tagChildhoodSweetheart: '幼馴染',
        tagBoss: '上司',
        tagSubordinate: '部下',
        tagTeacherStudent: '師弟',
        tagArchEnemy: '宿敵',
        tagStranger: '他人',
        tagContractPartner: '契約パートナー',
        tagRichFamily: '富豪',
        tagMafia: 'マフィア',
        tagDoctor: '医者',
        tagIdol: 'アイドル',
        tagAssassin: '暗殺者',
        tagMaid: 'メイド',
        tagLandlord: '大家',
        tagYandere: 'ヤンデレ',
        tagTsundere: 'ツンデレ',
        tagAloof: 'クール',
        tagShy: '恥ずかしがり屋',
        tagDominant: '強気',
        tagSubmissive: '従順',
        tagGentle: '優しい',
        tagAirhead: '天然',
        tagStrict: '厳格',
        tagObsessed: '執着',
        tagScheming: '腹黒',
        tagPureLove: '純愛',
        tagMilf: '熟女',
        tagDilf: '熟男',
        tagCurvy: 'グラマー',
        tagMuscular: 'マッチョ',
        tagPetite: '小柄',
        tagGothic: 'ゴシック',
        tagHotGirl: 'ホットガール',
        tagUniform: '制服',
        tagVampire: '吸血鬼',
        tagWerewolf: '狼人間',
        tagDemon: '悪魔',
        tagSuccubus: 'サキュバス',
        tagOrc: 'オーク',
        tagMonsterGirl: 'モンスター娘',
        tagRobot: 'ロボット',
        tagElf: 'エルフ',
        tagDoujin: '同人',
        tagAnime: 'アニメ',
        tagTwoDimensional: '二次元',
        tagWorkplace: '職場',
        tagSchool: '学園',
        tagFantasy: 'ファンタジー',
        tagUrban: '都市',
        tagBlindDate: 'お見合い',
        tagDark: 'ダーク',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALL',
            STEP_RELATIVE: '継親',
            ROOMMATE: 'ルームメイト',
            NEIGHBOR: '隣人',
            MARRIED: '既婚',
            EX: '元恋人',
            CHILDHOOD_SWEETHEART: '幼馴染',
            BOSS: '上司',
            SUBORDINATE: '部下',
            TEACHER_STUDENT: '師弟',
            ARCH_ENEMY: '宿敵',
            STRANGER: '他人',
            CONTRACT_PARTNER: '契約パートナー',
            RICH_FAMILY: '富豪',
            MAFIA: 'マフィア',
            DOCTOR: '医者',
            IDOL: 'アイドル',
            ASSASSIN: '暗殺者',
            MAID: 'メイド',
            LANDLORD: '大家',
            YANDERE: 'ヤンデレ',
            TSUNDERE: 'ツンデレ',
            ALOOF: 'クール',
            SHY: '恥ずかしがり屋',
            DOMINANT: '強気',
            SUBMISSIVE: '従順',
            GENTLE: '優しい',
            AIRHEAD: '天然',
            STRICT: '厳格',
            OBSESSED: '執着',
            SCHEMING: '腹黒',
            PURE_LOVE: '純愛',
            MILF: '熟女',
            DILF: '熟男',
            CURVY: 'グラマー',
            MUSCULAR: 'マッチョ',
            PETITE: '小柄',
            GOTHIC: 'ゴシック',
            HOT_GIRL: 'ホットガール',
            UNIFORM: '制服',
            VAMPIRE: '吸血鬼',
            WEREWOLF: '狼人間',
            DEMON: '悪魔',
            SUCCUBUS: 'サキュバス',
            ORC: 'オーク',
            MONSTER_GIRL: 'モンスター娘',
            ROBOT: 'ロボット',
            ELF: 'エルフ',
            DOUJIN: '同人',
            ANIME: 'アニメ',
            TWO_DIMENSIONAL: '二次元',
            WORKPLACE: '職場',
            SCHOOL: '学園',
            FANTASY: 'ファンタジー',
            URBAN: '都市',
            BLIND_DATE: 'お見合い',
            DARK: 'ダーク',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    ko: {
        loading: '로딩 중',
        pleaseWait: '잠시만 기다려주세요...',
        filter: '필터',
        recommend: '추천',
        latest: '최신',
        male: '남성',
        female: '여성',
        recent: '최근',
        noCharactersFound: '캐릭터를 찾을 수 없습니다',
        adjustFilters: '필터 조건을 조정해주세요',
        adjustFiltersSuggestion: '또는 다른 카테고리를 둘러보세요',
        resetAll: '전체 초기화',
        noDescription: '설명 없음',
        startChat: '채팅 시작',
        chat: '채팅',
        loadFailed: '로드 실패',
        noMoreData: '더 이상 없습니다',
        toast: {
            operationFailed: '작업 실패',
        },
        time: {
            justNow: '방금 전',
            minutesAgo: '분 전',
            hoursAgo: '시간 전',
            yesterday: '어제',
        },
        messageType: {
            image: '[이미지]',
            gifAnimation: '[GIF]',
            audio: '[음성]',
            touch3d: '[3D 터치]',
            card: '[카드]',
            tip: '[팁]',
            soul: '[소울]',
            media: '[미디어]',
            mateIntro: '[메이트 소개]',
            post: '[게시물]',
            novel: '[소설]',
            sceneSwitch: '[장면]',
        },
        genderFilter: '성별',
        interestTags: '관심 태그',
        resetFilter: '필터 초기화',
        messageList: '메시지 목록',
        recentChats: '최근 채팅',
        noMessages: '메시지 없음',
        noChatHistory: '채팅 기록 없음',
        noMoments: '모멘트 없음',
        continue: '계속',
        profile: '프로필',
        moments: '모멘트',
        characterIntro: '📝 캐릭터 소개',
        characterProfile: '🌟 캐릭터 설정',
        characterSetting: '🌟 캐릭터 설정',
        personality: '😇 성격',
        backgroundStory: '🏰 배경 스토리',
        interests: '💖 관심사',
        likes: '💕 좋아하는 것',
        dislikes: '💔 싫어하는 것',
        expand: '더보기',
        collapse: '접기',
        noIntro: '소개 없음',
        noMore: '더 이상 없습니다',
        gender: '성별',
        age: '나이',
        height: '키',
        weight: '체중',
        tagAll: '전체',
        tagStepRelative: '의붓 가족',
        tagRoommate: '룸메이트',
        tagNeighbor: '이웃',
        tagMarried: '기혼',
        tagEx: '전 애인',
        tagChildhoodSweetheart: '소꿉친구',
        tagBoss: '상사',
        tagSubordinate: '부하',
        tagTeacherStudent: '사제',
        tagArchEnemy: '숙적',
        tagStranger: '낯선 사람',
        tagContractPartner: '계약 파트너',
        tagRichFamily: '재벌',
        tagMafia: '마피아',
        tagDoctor: '의사',
        tagIdol: '아이돌',
        tagAssassin: '암살자',
        tagMaid: '메이드',
        tagLandlord: '집주인',
        tagYandere: '얀데레',
        tagTsundere: '츤데레',
        tagAloof: '차가움',
        tagShy: '수줍음',
        tagDominant: '강세',
        tagSubmissive: '순종',
        tagGentle: '온순',
        tagAirhead: '천연',
        tagStrict: '엄격',
        tagObsessed: '집착',
        tagScheming: '흑심',
        tagPureLove: '순애',
        tagMilf: '숙녀',
        tagDilf: '숙남',
        tagCurvy: '풍만',
        tagMuscular: '근육질',
        tagPetite: '쁘띠',
        tagGothic: '고딕',
        tagHotGirl: '섹시 걸',
        tagUniform: '제복',
        tagVampire: '뱀파이어',
        tagWerewolf: '늑대인간',
        tagDemon: '악마',
        tagSuccubus: '서큐버스',
        tagOrc: '오크',
        tagMonsterGirl: '몬스터 걸',
        tagRobot: '로봇',
        tagElf: '엘프',
        tagDoujin: '동인',
        tagAnime: '애니메이션',
        tagTwoDimensional: '2차원',
        tagWorkplace: '직장',
        tagSchool: '학교',
        tagFantasy: '판타지',
        tagUrban: '도시',
        tagBlindDate: '맞선',
        tagDark: '다크',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALL',
            STEP_RELATIVE: '의붓 가족',
            ROOMMATE: '룸메이트',
            NEIGHBOR: '이웃',
            MARRIED: '기혼',
            EX: '전 애인',
            CHILDHOOD_SWEETHEART: '소꿉친구',
            BOSS: '상사',
            SUBORDINATE: '부하',
            TEACHER_STUDENT: '사제',
            ARCH_ENEMY: '숙적',
            STRANGER: '낯선 사람',
            CONTRACT_PARTNER: '계약 파트너',
            RICH_FAMILY: '재벌',
            MAFIA: '마피아',
            DOCTOR: '의사',
            IDOL: '아이돌',
            ASSASSIN: '암살자',
            MAID: '메이드',
            LANDLORD: '집주인',
            YANDERE: '얀데레',
            TSUNDERE: '츤데레',
            ALOOF: '차가움',
            SHY: '수줍음',
            DOMINANT: '강세',
            SUBMISSIVE: '순종',
            GENTLE: '온순',
            AIRHEAD: '천연',
            STRICT: '엄격',
            OBSESSED: '집착',
            SCHEMING: '흑심',
            PURE_LOVE: '순애',
            MILF: '숙녀',
            DILF: '숙남',
            CURVY: '풍만',
            MUSCULAR: '근육질',
            PETITE: '쁘띠',
            GOTHIC: '고딕',
            HOT_GIRL: '섹시 걸',
            UNIFORM: '제복',
            VAMPIRE: '뱀파이어',
            WEREWOLF: '늑대인간',
            DEMON: '악마',
            SUCCUBUS: '서큐버스',
            ORC: '오크',
            MONSTER_GIRL: '몬스터 걸',
            ROBOT: '로봇',
            ELF: '엘프',
            DOUJIN: '동인',
            ANIME: '애니메이션',
            TWO_DIMENSIONAL: '2차원',
            WORKPLACE: '직장',
            SCHOOL: '학교',
            FANTASY: '판타지',
            URBAN: '도시',
            BLIND_DATE: '맞선',
            DARK: '다크',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    tw: {
        // 列表頁基礎UI
        loading: '正在載入',
        pleaseWait: '請稍候...',
        filter: '篩選',
        recommend: '推薦',
        latest: '最新',
        male: '男',
        female: '女',
        recent: '最近',
        
        // 空狀態
        noCharactersFound: '未找到角色',
        adjustFilters: '嘗試調整篩選條件',
        adjustFiltersSuggestion: '或瀏覽其他分類',
        resetAll: '重置全部',
        noDescription: '暫無描述',
        
        // 操作
        startChat: '開始聊天',
        chat: '聊天',
        
        // 載入狀態
        loadFailed: '載入失敗',
        noMoreData: '沒有更多了',
        
        // Toast訊息
        toast: {
            operationFailed: '操作失敗',
        },
        
        // 時間格式化
        time: {
            justNow: '剛剛聊過',
            minutesAgo: '分鐘前聊過',
            hoursAgo: '小時前聊過',
            yesterday: '昨天',
        },
        
        // 訊息類型
        messageType: {
            image: '[圖片]',
            gifAnimation: '[GIF動畫]',
            audio: '[語音]',
            touch3d: '[3dtouch]',
            card: '[卡片]',
            tip: '[提示]',
            soul: '[心聲]',
            media: '[媒體]',
            mateIntro: '[mate介紹]',
            post: '[動態]',
            novel: '[小說]',
            sceneSwitch: '[場景]',
        },
        
        // 篩選相關
        genderFilter: '性別篩選',
        interestTags: '興趣標籤',
        resetFilter: '重置篩選',
        
        // 聊天列表
        messageList: '訊息列表',
        recentChats: '最近聊天',
        noMessages: '暫無訊息',
        noChatHistory: '暫無聊天記錄',
        noMoments: '暫無動態',
        continue: '繼續',
        
        // 詳情頁tab
        profile: '資料',
        moments: '動態',
        characterIntro: '📝 人物簡介',
        characterProfile: '🌟 人設描述',
        characterSetting: '🌟 人設描述',
        personality: '😇 性格',
        backgroundStory: '🏰 背景故事',
        interests: '💖 興趣愛好',
        likes: '💕 喜歡的事物',
        dislikes: '💔 不喜歡的事物',
        expand: '展開',
        collapse: '收起',
        noIntro: '暫無介紹',
        noMore: '沒有更多了',
        
        // Info labels
        gender: '性別',
        age: '年齡',
        height: '身高',
        weight: '體重',
        
        // 標籤 - 用於index.vue（tagXXX格式）
        tagAll: 'ALL',
        tagStepRelative: '繼親',
        tagRoommate: '室友',
        tagNeighbor: '鄰居',
        tagMarried: '已婚',
        tagEx: '前任',
        tagChildhoodSweetheart: '青梅竹馬',
        tagBoss: '上司',
        tagSubordinate: '下屬',
        tagTeacherStudent: '師生',
        tagArchEnemy: '死對頭',
        tagStranger: '陌生人',
        tagContractPartner: '契約伴侶',
        tagRichFamily: '豪門',
        tagMafia: '黑幫',
        tagDoctor: '醫生',
        tagIdol: '偶像',
        tagAssassin: '殺手',
        tagMaid: '女僕',
        tagLandlord: '房東',
        tagYandere: '病嬌',
        tagTsundere: '傲嬌',
        tagAloof: '高冷',
        tagShy: '害羞',
        tagDominant: '強勢',
        tagSubmissive: '順從',
        tagGentle: '溫柔',
        tagAirhead: '天然呆',
        tagStrict: '嚴厲',
        tagObsessed: '癡迷',
        tagScheming: '腹黑',
        tagPureLove: '純愛',
        tagMilf: '熟女',
        tagDilf: '熟男',
        tagCurvy: '豐滿',
        tagMuscular: '肌肉',
        tagPetite: '嬌小',
        tagGothic: '哥德',
        tagHotGirl: '辣妹',
        tagUniform: '制服',
        tagVampire: '吸血鬼',
        tagWerewolf: '狼人',
        tagDemon: '惡魔',
        tagSuccubus: '魅魔',
        tagOrc: '獸人',
        tagMonsterGirl: '魔物娘',
        tagRobot: '機器人',
        tagElf: '精靈',
        tagDoujin: '同人',
        tagAnime: '動漫',
        tagTwoDimensional: '二次元',
        tagWorkplace: '職場',
        tagSchool: '校園',
        tagFantasy: '奇幻',
        tagUrban: '都市',
        tagBlindDate: '相親',
        tagDark: '暗黑',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALL',
            STEP_RELATIVE: '繼親',
            ROOMMATE: '室友',
            NEIGHBOR: '鄰居',
            MARRIED: '已婚',
            EX: '前任',
            CHILDHOOD_SWEETHEART: '青梅竹馬',
            BOSS: '上司',
            SUBORDINATE: '下屬',
            TEACHER_STUDENT: '師生',
            ARCH_ENEMY: '死對頭',
            STRANGER: '陌生人',
            CONTRACT_PARTNER: '契約伴侶',
            RICH_FAMILY: '豪門',
            MAFIA: '黑幫',
            DOCTOR: '醫生',
            IDOL: '偶像',
            ASSASSIN: '殺手',
            MAID: '女僕',
            LANDLORD: '房東',
            YANDERE: '病嬌',
            TSUNDERE: '傲嬌',
            ALOOF: '高冷',
            SHY: '害羞',
            DOMINANT: '強勢',
            SUBMISSIVE: '順從',
            GENTLE: '溫柔',
            AIRHEAD: '天然呆',
            STRICT: '嚴厲',
            OBSESSED: '癡迷',
            SCHEMING: '腹黑',
            PURE_LOVE: '純愛',
            MILF: '熟女',
            DILF: '熟男',
            CURVY: '豐滿',
            MUSCULAR: '肌肉',
            PETITE: '嬌小',
            GOTHIC: '哥德',
            HOT_GIRL: '辣妹',
            UNIFORM: '制服',
            VAMPIRE: '吸血鬼',
            WEREWOLF: '狼人',
            DEMON: '惡魔',
            SUCCUBUS: '魅魔',
            ORC: '獸人',
            MONSTER_GIRL: '魔物娘',
            ROBOT: '機器人',
            ELF: '精靈',
            DOUJIN: '同人',
            ANIME: '動漫',
            TWO_DIMENSIONAL: '二次元',
            WORKPLACE: '職場',
            SCHOOL: '校園',
            FANTASY: '奇幻',
            URBAN: '都市',
            BLIND_DATE: '相親',
            DARK: '暗黑',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    pl: {
        // Podstawowy interfejs strony listy
        loading: 'Ładowanie',
        pleaseWait: 'Proszę czekać...',
        filter: 'Filtr',
        recommend: 'Polecane',
        latest: 'Najnowsze',
        male: 'Mężczyzna',
        female: 'Kobieta',
        recent: 'Ostatnie',
        
        // Puste stany
        noCharactersFound: 'Nie znaleziono postaci',
        adjustFilters: 'Spróbuj dostosować filtry',
        adjustFiltersSuggestion: 'lub przeglądaj inne kategorie',
        resetAll: 'Resetuj wszystko',
        noDescription: 'Brak opisu',
        
        // Akcje
        startChat: 'Rozpocznij czat',
        chat: 'Czat',
        // Stany ładowania
        loadFailed: 'Ładowanie nie powiodło się',
        noMoreData: 'Brak więcej danych',
        
        // Komunikaty Toast
        toast: {
            operationFailed: 'Operacja nie powiodła się',
        },
        
        // Formatowanie czasu
        time: {
            justNow: 'Przed chwilą',
            minutesAgo: 'min temu',
            hoursAgo: 'godz. temu',
            yesterday: 'Wczoraj',
        },
        
        // Typy wiadomości
        messageType: {
            image: '[Obraz]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Karta]',
            tip: '[Wskazówka]',
            soul: '[Dusza]',
            media: '[Media]',
            mateIntro: '[Prezentacja partnera]',
            post: '[Post]',
            novel: '[Powieść]',
            sceneSwitch: '[Scena]',
        },
        
        // Filtry
        genderFilter: 'Płeć',
        interestTags: 'Zainteresowania',
        resetFilter: 'Resetuj filtr',
        
        // Lista czatów
        messageList: 'Lista wiadomości',
        recentChats: 'Ostatnie czaty',
        noMessages: 'Brak wiadomości',
        noChatHistory: 'Brak historii czatu',
        noMoments: 'Brak momentów',
        continue: 'Kontynuuj',
        
        // Zakładki strony szczegółów
        profile: 'Profil',
        moments: 'Momenty',
        characterIntro: '📝 Wprowadzenie postaci',
        characterProfile: '🌟 Profil postaci',
        characterSetting: '🌟 Ustawienia postaci',
        personality: '😇 Osobowość',
        backgroundStory: '🏰 Historia',
        interests: '💖 Zainteresowania',
        likes: '💕 Polubienia',
        dislikes: '💔 Nie lubi',
        expand: 'Rozwiń',
        collapse: 'Zwiń',
        noIntro: 'Brak wprowadzenia',
        noMore: 'Brak więcej',
        
        // Etykiety informacji
        gender: 'Płeć',
        age: 'Wiek',
        height: 'Wzrost',
        weight: 'Waga',
        
        // Tagi - dla index.vue (format tagXXX)
        tagAll: 'WSZYSTKIE',
        tagStepRelative: 'Przybrany krewny',
        tagRoommate: 'Współlokator',
        tagNeighbor: 'Sąsiad',
        tagMarried: 'Żonaty/Zamężna',
        tagEx: 'Były/Była',
        tagChildhoodSweetheart: 'Miłość z dzieciństwa',
        tagBoss: 'Szef',
        tagSubordinate: 'Podwładny',
        tagTeacherStudent: 'Nauczyciel/Uczeń',
        tagArchEnemy: 'Arcywróg',
        tagStranger: 'Nieznajomy',
        tagContractPartner: 'Partner kontraktowy',
        tagRichFamily: 'Bogata rodzina',
        tagMafia: 'Mafia',
        tagDoctor: 'Lekarz',
        tagIdol: 'Idol',
        tagAssassin: 'Zabójca',
        tagMaid: 'Pokojówka',
        tagLandlord: 'Właściciel',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Zdystansowany',
        tagShy: 'Nieśmiały',
        tagDominant: 'Dominujący',
        tagSubmissive: 'Uległy',
        tagGentle: 'Łagodny',
        tagAirhead: 'Roztargniony',
        tagStrict: 'Surowy',
        tagObsessed: 'Opętany',
        tagScheming: 'Intrygujący',
        tagPureLove: 'Czysta miłość',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Krągły',
        tagMuscular: 'Muskularny',
        tagPetite: 'Drobny',
        tagGothic: 'Gotycki',
        tagHotGirl: 'Gorąca dziewczyna',
        tagUniform: 'Mundur',
        tagVampire: 'Wampir',
        tagWerewolf: 'Wilkołak',
        tagDemon: 'Demon',
        tagSuccubus: 'Sukub',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Dziewczyna-potwór',
        tagRobot: 'Robot',
        tagElf: 'Elf',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Miejsce pracy',
        tagSchool: 'Szkoła',
        tagFantasy: 'Fantastyka',
        tagUrban: 'Miejski',
        tagBlindDate: 'Randka w ciemno',
        tagDark: 'Mroczny',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tagi
        tags: {
            ALL: 'WSZYSTKIE',
            STEP_RELATIVE: 'Przybrany krewny',
            ROOMMATE: 'Współlokator',
            NEIGHBOR: 'Sąsiad',
            MARRIED: 'Żonaty/Zamężna',
            EX: 'Były/Była',
            CHILDHOOD_SWEETHEART: 'Miłość z dzieciństwa',
            BOSS: 'Szef',
            SUBORDINATE: 'Podwładny',
            TEACHER_STUDENT: 'Nauczyciel/Uczeń',
            ARCH_ENEMY: 'Arcywróg',
            STRANGER: 'Nieznajomy',
            CONTRACT_PARTNER: 'Partner kontraktowy',
            RICH_FAMILY: 'Bogata rodzina',
            MAFIA: 'Mafia',
            DOCTOR: 'Lekarz',
            IDOL: 'Idol',
            ASSASSIN: 'Zabójca',
            MAID: 'Pokojówka',
            LANDLORD: 'Właściciel',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Zdystansowany',
            SHY: 'Nieśmiały',
            DOMINANT: 'Dominujący',
            SUBMISSIVE: 'Uległy',
            GENTLE: 'Łagodny',
            AIRHEAD: 'Roztargniony',
            STRICT: 'Surowy',
            OBSESSED: 'Opętany',
            SCHEMING: 'Intrygujący',
            PURE_LOVE: 'Czysta miłość',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Krągły',
            MUSCULAR: 'Muskularny',
            PETITE: 'Drobny',
            GOTHIC: 'Gotycki',
            HOT_GIRL: 'Gorąca dziewczyna',
            UNIFORM: 'Mundur',
            VAMPIRE: 'Wampir',
            WEREWOLF: 'Wilkołak',
            DEMON: 'Demon',
            SUCCUBUS: 'Sukub',
            ORC: 'Ork',
            MONSTER_GIRL: 'Dziewczyna-potwór',
            ROBOT: 'Robot',
            ELF: 'Elf',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Miejsce pracy',
            SCHOOL: 'Szkoła',
            FANTASY: 'Fantastyka',
            URBAN: 'Miejski',
            BLIND_DATE: 'Randka w ciemno',
            DARK: 'Mroczny',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    es: {
        loading: 'Cargando',
        pleaseWait: 'Por favor espere...',
        filter: 'Filtrar',
        recommend: 'Recomendados',
        latest: 'Últimos',
        male: 'Masculino',
        female: 'Femenino',
        recent: 'Reciente',
        noCharactersFound: 'No se encontraron personajes',
        adjustFilters: 'Intente ajustar sus filtros',
        adjustFiltersSuggestion: 'o explore otras categorías',
        resetAll: 'Restablecer Todo',
        noDescription: 'Sin Descripción',
        startChat: 'Iniciar Chat',
        chat: 'Chat',
        loadFailed: 'Error de Carga',
        noMoreData: 'No hay más datos',
        toast: {
            operationFailed: 'Operación Fallida',
        },
        time: {
            justNow: 'Ahora',
            minutesAgo: 'min',
            hoursAgo: 'h',
            yesterday: 'Ayer',
        },
        messageType: {
            image: '[Imagen]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[Toque 3D]',
            card: '[Tarjeta]',
            tip: '[Consejo]',
            soul: '[Alma]',
            media: '[Medios]',
            mateIntro: '[Intro de Mate]',
            post: '[Publicación]',
            novel: '[Novela]',
            sceneSwitch: '[Escena]',
        },
        genderFilter: 'Género',
        interestTags: 'Etiquetas',
        resetFilter: 'Restablecer Filtro',
        messageList: 'Lista de Mensajes',
        recentChats: 'Chats Recientes',
        noMessages: 'Sin Mensajes',
        noChatHistory: 'Sin Historial de Chat',
        noMoments: 'Sin Momentos',
        continue: 'Continuar',
        profile: 'Perfil',
        moments: 'Momentos',
        characterIntro: '📝 Introducción del Personaje',
        characterProfile: '🌟 Perfil del Personaje',
        characterSetting: '🌟 Configuración del Personaje',
        personality: '😇 Personalidad',
        backgroundStory: '🏰 Historia de Fondo',
        interests: '💖 Intereses',
        likes: '💕 Le Gusta',
        dislikes: '💔 No Le Gusta',
        expand: 'Expandir',
        collapse: 'Colapsar',
        noIntro: 'Sin Introducción',
        noMore: 'No hay más',
        gender: 'Género',
        age: 'Edad',
        height: 'Altura',
        weight: 'Peso',
        tagAll: 'Todos',
        tagStepRelative: 'Familiar Político',
        tagRoommate: 'Compañero de Cuarto',
        tagNeighbor: 'Vecino',
        tagMarried: 'Casado',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Amor de Infancia',
        tagBoss: 'Jefe',
        tagSubordinate: 'Subordinado',
        tagTeacherStudent: 'Maestro/Estudiante',
        tagArchEnemy: 'Archienemigo',
        tagStranger: 'Extraño',
        tagContractPartner: 'Socio Contractual',
        tagRichFamily: 'Familia Rica',
        tagMafia: 'Mafia',
        tagDoctor: 'Doctor',
        tagIdol: 'Ídolo',
        tagAssassin: 'Asesino',
        tagMaid: 'Sirvienta',
        tagLandlord: 'Propietario',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Distante',
        tagShy: 'Tímido',
        tagDominant: 'Dominante',
        tagSubmissive: 'Sumiso',
        tagGentle: 'Amable',
        tagAirhead: 'Despistado',
        tagStrict: 'Estricto',
        tagObsessed: 'Obsesionado',
        tagScheming: 'Maquinador',
        tagPureLove: 'Amor Puro',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Curvilínea',
        tagMuscular: 'Musculoso',
        tagPetite: 'Menuda',
        tagGothic: 'Gótico',
        tagHotGirl: 'Chica Sexy',
        tagUniform: 'Uniforme',
        tagVampire: 'Vampiro',
        tagWerewolf: 'Hombre Lobo',
        tagDemon: 'Demonio',
        tagSuccubus: 'Súcubo',
        tagOrc: 'Orco',
        tagMonsterGirl: 'Chica Monstruo',
        tagRobot: 'Robot',
        tagElf: 'Elfo',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Trabajo',
        tagSchool: 'Escuela',
        tagFantasy: 'Fantasía',
        tagUrban: 'Urbano',
        tagBlindDate: 'Cita a Ciegas',
        tagDark: 'Oscuro',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'Todos',
            STEP_RELATIVE: 'Familiar Político',
            ROOMMATE: 'Compañero de Cuarto',
            NEIGHBOR: 'Vecino',
            MARRIED: 'Casado',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Amor de Infancia',
            BOSS: 'Jefe',
            SUBORDINATE: 'Subordinado',
            TEACHER_STUDENT: 'Maestro/Estudiante',
            ARCH_ENEMY: 'Archienemigo',
            STRANGER: 'Extraño',
            CONTRACT_PARTNER: 'Socio Contractual',
            RICH_FAMILY: 'Familia Rica',
            MAFIA: 'Mafia',
            DOCTOR: 'Doctor',
            IDOL: 'Ídolo',
            ASSASSIN: 'Asesino',
            MAID: 'Sirvienta',
            LANDLORD: 'Propietario',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Distante',
            SHY: 'Tímido',
            DOMINANT: 'Dominante',
            SUBMISSIVE: 'Sumiso',
            GENTLE: 'Amable',
            AIRHEAD: 'Despistado',
            STRICT: 'Estricto',
            OBSESSED: 'Obsesionado',
            SCHEMING: 'Maquinador',
            PURE_LOVE: 'Amor Puro',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Curvilínea',
            MUSCULAR: 'Musculoso',
            PETITE: 'Menuda',
            GOTHIC: 'Gótico',
            HOT_GIRL: 'Chica Sexy',
            UNIFORM: 'Uniforme',
            VAMPIRE: 'Vampiro',
            WEREWOLF: 'Hombre Lobo',
            DEMON: 'Demonio',
            SUCCUBUS: 'Súcubo',
            ORC: 'Orco',
            MONSTER_GIRL: 'Chica Monstruo',
            ROBOT: 'Robot',
            ELF: 'Elfo',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Trabajo',
            SCHOOL: 'Escuela',
            FANTASY: 'Fantasía',
            URBAN: 'Urbano',
            BLIND_DATE: 'Cita a Ciegas',
            DARK: 'Oscuro',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    fr: {
        loading: 'Chargement',
        pleaseWait: 'Veuillez patienter...',
        filter: 'Filtrer',
        recommend: 'Recommandés',
        latest: 'Derniers',
        male: 'Homme',
        female: 'Femme',
        recent: 'Récent',
        noCharactersFound: 'Aucun Personnage Trouvé',
        adjustFilters: 'Essayez d\'ajuster vos filtres',
        adjustFiltersSuggestion: 'ou explorez d\'autres catégories',
        resetAll: 'Tout Réinitialiser',
        noDescription: 'Aucune Description',
        startChat: 'Commencer le Chat',
        chat: 'Chat',
        loadFailed: 'Échec du Chargement',
        noMoreData: 'Plus de Données',
        toast: {
            operationFailed: 'Opération Échouée',
        },
        time: {
            justNow: 'À l\'instant',
            minutesAgo: 'il y a {n} min',
            hoursAgo: 'il y a {n} h',
            yesterday: 'Hier',
        },
        messageType: {
            image: '[Image]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Carte]',
            tip: '[Conseil]',
            soul: '[Âme]',
            media: '[Média]',
            mateIntro: '[Intro Mate]',
            post: '[Publication]',
            novel: '[Roman]',
            sceneSwitch: '[Scène]',
        },
        genderFilter: 'Genre',
        interestTags: 'Tags',
        resetFilter: 'Réinitialiser le Filtre',
        messageList: 'Liste des Messages',
        recentChats: 'Discussions Récentes',
        noMessages: 'Aucun Message',
        noChatHistory: "Aucun Historique de Chat",
        noMoments: 'Aucun Moment',
        continue: 'Continuer',
        profile: 'Profil',
        moments: 'Moments',
        characterIntro: '📝 Introduction du Personnage',
        characterProfile: '🌟 Profil du Personnage',
        characterSetting: '🌟 Configuration du Personnage',
        personality: '😇 Personnalité',
        backgroundStory: '🏰 Histoire de Fond',
        interests: '💖 Intérêts',
        likes: '💕 Aime',
        dislikes: "💔 N'aime Pas",
        expand: 'Développer',
        collapse: 'Réduire',
        noIntro: 'Aucune Introduction',
        noMore: 'Plus de données',
        gender: 'Genre',
        age: 'Âge',
        height: 'Taille',
        weight: 'Poids',
        tagAll: 'TOUS',
        tagStepRelative: 'Beau-Parent',
        tagRoommate: 'Colocataire',
        tagNeighbor: 'Voisin',
        tagMarried: 'Marié',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Amour d\'Enfance',
        tagBoss: 'Patron',
        tagSubordinate: 'Subordonné',
        tagTeacherStudent: 'Maître/Élève',
        tagArchEnemy: 'Ennemi Juré',
        tagStranger: 'Étranger',
        tagContractPartner: 'Partenaire Contractuel',
        tagRichFamily: 'Famille Riche',
        tagMafia: 'Mafia',
        tagDoctor: 'Docteur',
        tagIdol: 'Idole',
        tagAssassin: 'Assassin',
        tagMaid: 'Femme de Chambre',
        tagLandlord: 'Propriétaire',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Distant',
        tagShy: 'Timide',
        tagDominant: 'Dominant',
        tagSubmissive: 'Soumis',
        tagGentle: 'Doux',
        tagAirhead: 'Tête en l\'Air',
        tagStrict: 'Strict',
        tagObsessed: 'Obsédé',
        tagScheming: 'Manipulateur',
        tagPureLove: 'Amour Pur',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Voluptueux',
        tagMuscular: 'Musclé',
        tagPetite: 'Petite',
        tagGothic: 'Gothique',
        tagHotGirl: 'Fille Sexy',
        tagUniform: 'Uniforme',
        tagVampire: 'Vampire',
        tagWerewolf: 'Loup-Garou',
        tagDemon: 'Démon',
        tagSuccubus: 'Succube',
        tagOrc: 'Orc',
        tagMonsterGirl: 'Fille Monstre',
        tagRobot: 'Robot',
        tagElf: 'Elfe',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Lieu de Travail',
        tagSchool: 'École',
        tagFantasy: 'Fantaisie',
        tagUrban: 'Urbain',
        tagBlindDate: 'Rendez-vous Aveugle',
        tagDark: 'Sombre',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'TOUS',
            STEP_RELATIVE: 'Beau-Parent',
            ROOMMATE: 'Colocataire',
            NEIGHBOR: 'Voisin',
            MARRIED: 'Marié',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Amour d\'Enfance',
            BOSS: 'Patron',
            SUBORDINATE: 'Subordonné',
            TEACHER_STUDENT: 'Maître/Élève',
            ARCH_ENEMY: 'Ennemi Juré',
            STRANGER: 'Étranger',
            CONTRACT_PARTNER: 'Partenaire Contractuel',
            RICH_FAMILY: 'Famille Riche',
            MAFIA: 'Mafia',
            DOCTOR: 'Docteur',
            IDOL: 'Idole',
            ASSASSIN: 'Assassin',
            MAID: 'Femme de Chambre',
            LANDLORD: 'Propriétaire',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Distant',
            SHY: 'Timide',
            DOMINANT: 'Dominant',
            SUBMISSIVE: 'Soumis',
            GENTLE: 'Doux',
            AIRHEAD: 'Tête en l\'Air',
            STRICT: 'Strict',
            OBSESSED: 'Obsédé',
            SCHEMING: 'Manipulateur',
            PURE_LOVE: 'Amour Pur',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Voluptueux',
            MUSCULAR: 'Musclé',
            PETITE: 'Petite',
            GOTHIC: 'Gothique',
            HOT_GIRL: 'Fille Sexy',
            UNIFORM: 'Uniforme',
            VAMPIRE: 'Vampire',
            WEREWOLF: 'Loup-Garou',
            DEMON: 'Démon',
            SUCCUBUS: 'Succube',
            ORC: 'Orc',
            MONSTER_GIRL: 'Fille Monstre',
            ROBOT: 'Robot',
            ELF: 'Elfe',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Lieu de Travail',
            SCHOOL: 'École',
            FANTASY: 'Fantaisie',
            URBAN: 'Urbain',
            BLIND_DATE: 'Rendez-vous Aveugle',
            DARK: 'Sombre',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    de: {
        loading: 'Lädt',
        pleaseWait: 'Bitte warten...',
        filter: 'Filter',
        recommend: 'Empfohlen',
        latest: 'Neueste',
        male: 'Männlich',
        female: 'Weiblich',
        recent: 'Kürzlich',
        noCharactersFound: 'Keine Charaktere Gefunden',
        adjustFilters: 'Versuchen Sie, Ihre Filter anzupassen',
        adjustFiltersSuggestion: 'oder andere Kategorien durchsuchen',
        resetAll: 'Alles Zurücksetzen',
        noDescription: 'Keine Beschreibung',
        startChat: 'Chat Starten',
        chat: 'Chat',
        loadFailed: 'Laden Fehlgeschlagen',
        noMoreData: 'Keine Weiteren Daten',
        toast: {
            operationFailed: 'Operation Fehlgeschlagen',
        },
        time: {
            justNow: 'Gerade eben',
            minutesAgo: 'vor Min.',
            hoursAgo: 'vor Std.',
            yesterday: 'Gestern',
        },
        messageType: {
            image: '[Bild]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Karte]',
            tip: '[Tipp]',
            soul: '[Seele]',
            media: '[Medien]',
            mateIntro: '[Mate Intro]',
            post: '[Beitrag]',
            novel: '[Roman]',
            sceneSwitch: '[Szene]',
        },
        genderFilter: 'Geschlecht',
        interestTags: 'Tags',
        resetFilter: 'Filter Zurücksetzen',
        messageList: 'Nachrichtenliste',
        recentChats: 'Letzte Chats',
        noMessages: 'Keine Nachrichten',
        noChatHistory: 'Kein Chat-Verlauf',
        noMoments: 'Keine Momente',
        continue: 'Fortsetzen',
        profile: 'Profil',
        moments: 'Momente',
        characterIntro: '📝 Charaktereinführung',
        characterProfile: '🌟 Charakterprofil',
        characterSetting: '🌟 Charaktereinstellung',
        personality: '😇 Persönlichkeit',
        backgroundStory: '🏰 Hintergrundgeschichte',
        interests: '💖 Interessen',
        likes: '💕 Mag',
        dislikes: '💔 Mag Nicht',
        expand: 'Erweitern',
        collapse: 'Einklappen',
        noIntro: 'Keine Einführung',
        noMore: 'Keine Weiteren Daten',
        gender: 'Geschlecht',
        age: 'Alter',
        height: 'Größe',
        weight: 'Gewicht',
        tagAll: 'ALLE',
        tagStepRelative: 'Stiefverwandter',
        tagRoommate: 'Mitbewohner',
        tagNeighbor: 'Nachbar',
        tagMarried: 'Verheiratet',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Jugendliebe',
        tagBoss: 'Chef',
        tagSubordinate: 'Untergeordneter',
        tagTeacherStudent: 'Lehrer/Schüler',
        tagArchEnemy: 'Erzfeind',
        tagStranger: 'Fremder',
        tagContractPartner: 'Vertragspartner',
        tagRichFamily: 'Reiche Familie',
        tagMafia: 'Mafia',
        tagDoctor: 'Arzt',
        tagIdol: 'Idol',
        tagAssassin: 'Assassine',
        tagMaid: 'Dienstmädchen',
        tagLandlord: 'Vermieter',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Distanziert',
        tagShy: 'Schüchtern',
        tagDominant: 'Dominant',
        tagSubmissive: 'Unterwürfig',
        tagGentle: 'Sanft',
        tagAirhead: 'Naiv',
        tagStrict: 'Streng',
        tagObsessed: 'Besessen',
        tagScheming: 'Hinterhältig',
        tagPureLove: 'Reine Liebe',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Kurvig',
        tagMuscular: 'Muskulös',
        tagPetite: 'Zierlich',
        tagGothic: 'Gotisch',
        tagHotGirl: 'Heißes Mädchen',
        tagUniform: 'Uniform',
        tagVampire: 'Vampir',
        tagWerewolf: 'Werwolf',
        tagDemon: 'Dämon',
        tagSuccubus: 'Sukkubus',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Monstermädchen',
        tagRobot: 'Roboter',
        tagElf: 'Elf',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Arbeitsplatz',
        tagSchool: 'Schule',
        tagFantasy: 'Fantasie',
        tagUrban: 'Urban',
        tagBlindDate: 'Blind Date',
        tagDark: 'Dunkel',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALLE',
            STEP_RELATIVE: 'Stiefverwandter',
            ROOMMATE: 'Mitbewohner',
            NEIGHBOR: 'Nachbar',
            MARRIED: 'Verheiratet',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Jugendliebe',
            BOSS: 'Chef',
            SUBORDINATE: 'Untergeordneter',
            TEACHER_STUDENT: 'Lehrer/Schüler',
            ARCH_ENEMY: 'Erzfeind',
            STRANGER: 'Fremder',
            CONTRACT_PARTNER: 'Vertragspartner',
            RICH_FAMILY: 'Reiche Familie',
            MAFIA: 'Mafia',
            DOCTOR: 'Arzt',
            IDOL: 'Idol',
            ASSASSIN: 'Assassine',
            MAID: 'Dienstmädchen',
            LANDLORD: 'Vermieter',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Distanziert',
            SHY: 'Schüchtern',
            DOMINANT: 'Dominant',
            SUBMISSIVE: 'Unterwürfig',
            GENTLE: 'Sanft',
            AIRHEAD: 'Naiv',
            STRICT: 'Streng',
            OBSESSED: 'Besessen',
            SCHEMING: 'Hinterhältig',
            PURE_LOVE: 'Reine Liebe',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Kurvig',
            MUSCULAR: 'Muskulös',
            PETITE: 'Zierlich',
            GOTHIC: 'Gotisch',
            HOT_GIRL: 'Heißes Mädchen',
            UNIFORM: 'Uniform',
            VAMPIRE: 'Vampir',
            WEREWOLF: 'Werwolf',
            DEMON: 'Dämon',
            SUCCUBUS: 'Sukkubus',
            ORC: 'Ork',
            MONSTER_GIRL: 'Monstermädchen',
            ROBOT: 'Roboter',
            ELF: 'Elf',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Arbeitsplatz',
            SCHOOL: 'Schule',
            FANTASY: 'Fantasie',
            URBAN: 'Urban',
            BLIND_DATE: 'Blind Date',
            DARK: 'Dunkel',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    ru: {
        loading: 'Загрузка',
        pleaseWait: 'Пожалуйста, подождите...',
        filter: 'Фильтр',
        recommend: 'Реком.',
        latest: 'Последние',
        male: 'Мужской',
        female: 'Женский',
        recent: 'Недавние',
        noCharactersFound: 'Персонажи Не Найдены',
        adjustFilters: 'Попробуйте настроить фильтры',
        adjustFiltersSuggestion: 'или просмотрите другие категории',
        resetAll: 'Сбросить Все',
        noDescription: 'Нет Описания',
        startChat: 'Начать Чат',
        chat: 'Чат',
        loadFailed: 'Ошибка Загрузки',
        noMoreData: 'Больше Нет Данных',
        toast: {
            operationFailed: 'Операция Не Удалась',
        },
        time: {
            justNow: 'Только что',
            minutesAgo: 'мин. назад',
            hoursAgo: 'ч. назад',
            yesterday: 'Вчера',
        },
        messageType: {
            image: '[Изображение]',
            gifAnimation: '[GIF]',
            audio: '[Аудио]',
            touch3d: '[3D Touch]',
            card: '[Карта]',
            tip: '[Совет]',
            soul: '[Душа]',
            media: '[Медиа]',
            mateIntro: '[Intro Mate]',
            post: '[Пост]',
            novel: '[Роман]',
            sceneSwitch: '[Сцена]',
        },
        genderFilter: 'Пол',
        interestTags: 'Теги',
        resetFilter: 'Сбросить Фильтр',
        messageList: 'Список Сообщений',
        recentChats: 'Недавние Чаты',
        noMessages: 'Нет Сообщений',
        noChatHistory: 'Нет Истории Чата',
        noMoments: 'Нет Моментов',
        continue: 'Продолжить',
        profile: 'Профиль',
        moments: 'Моменты',
        characterIntro: '📝 Представление Персонажа',
        characterProfile: '🌟 Профиль Персонажа',
        characterSetting: '🌟 Настройка Персонажа',
        personality: '😇 Личность',
        backgroundStory: '🏰 Предыстория',
        interests: '💖 Интересы',
        likes: '💕 Нравится',
        dislikes: '💔 Не Нравится',
        expand: 'Развернуть',
        collapse: 'Свернуть',
        noIntro: 'Нет Представления',
        noMore: 'Больше Нет Данных',
        gender: 'Пол',
        age: 'Возраст',
        height: 'Рост',
        weight: 'Вес',
        tagAll: 'ВСЕ',
        tagStepRelative: 'Неродной Родственник',
        tagRoommate: 'Сосед по Комнате',
        tagNeighbor: 'Сосед',
        tagMarried: 'Женат',
        tagEx: 'Бывший',
        tagChildhoodSweetheart: 'Любовь Детства',
        tagBoss: 'Босс',
        tagSubordinate: 'Подчиненный',
        tagTeacherStudent: 'Учитель/Ученик',
        tagArchEnemy: 'Заклятый Враг',
        tagStranger: 'Незнакомец',
        tagContractPartner: 'Партнер по Контракту',
        tagRichFamily: 'Богатая Семья',
        tagMafia: 'Мафия',
        tagDoctor: 'Доктор',
        tagIdol: 'Идол',
        tagAssassin: 'Убийца',
        tagMaid: 'Горничная',
        tagLandlord: 'Арендодатель',
        tagYandere: 'Яндере',
        tagTsundere: 'Цундере',
        tagAloof: 'Отстраненный',
        tagShy: 'Застенчивый',
        tagDominant: 'Доминирующий',
        tagSubmissive: 'Покорный',
        tagGentle: 'Нежный',
        tagAirhead: 'Простачок',
        tagStrict: 'Строгий',
        tagObsessed: 'Одержимый',
        tagScheming: 'Коварный',
        tagPureLove: 'Чистая Любовь',
        tagMilf: 'МИЛФ',
        tagDilf: 'ДИЛФ',
        tagCurvy: 'Пышная',
        tagMuscular: 'Мускулистый',
        tagPetite: 'Миниатюрная',
        tagGothic: 'Готический',
        tagHotGirl: 'Горячая Девушка',
        tagUniform: 'Униформа',
        tagVampire: 'Вампир',
        tagWerewolf: 'Оборотень',
        tagDemon: 'Демон',
        tagSuccubus: 'Суккуб',
        tagOrc: 'Орк',
        tagMonsterGirl: 'Девушка-Монстр',
        tagRobot: 'Робот',
        tagElf: 'Эльф',
        tagDoujin: 'Додзин',
        tagAnime: 'Аниме',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Рабочее Место',
        tagSchool: 'Школа',
        tagFantasy: 'Фантазия',
        tagUrban: 'Городской',
        tagBlindDate: 'Свидание Вслепую',
        tagDark: 'Темный',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'ЛГБТ',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ВСЕ',
            STEP_RELATIVE: 'Неродной Родственник',
            ROOMMATE: 'Сосед по Комнате',
            NEIGHBOR: 'Сосед',
            MARRIED: 'Женат',
            EX: 'Бывший',
            CHILDHOOD_SWEETHEART: 'Любовь Детства',
            BOSS: 'Босс',
            SUBORDINATE: 'Подчиненный',
            TEACHER_STUDENT: 'Учитель/Ученик',
            ARCH_ENEMY: 'Заклятый Враг',
            STRANGER: 'Незнакомец',
            CONTRACT_PARTNER: 'Партнер по Контракту',
            RICH_FAMILY: 'Богатая Семья',
            MAFIA: 'Мафия',
            DOCTOR: 'Доктор',
            IDOL: 'Идол',
            ASSASSIN: 'Убийца',
            MAID: 'Горничная',
            LANDLORD: 'Арендодатель',
            YANDERE: 'Яндере',
            TSUNDERE: 'Цундере',
            ALOOF: 'Отстраненный',
            SHY: 'Застенчивый',
            DOMINANT: 'Доминирующий',
            SUBMISSIVE: 'Покорный',
            GENTLE: 'Нежный',
            AIRHEAD: 'Простачок',
            STRICT: 'Строгий',
            OBSESSED: 'Одержимый',
            SCHEMING: 'Коварный',
            PURE_LOVE: 'Чистая Любовь',
            MILF: 'МИЛФ',
            DILF: 'ДИЛФ',
            CURVY: 'Пышная',
            MUSCULAR: 'Мускулистый',
            PETITE: 'Миниатюрная',
            GOTHIC: 'Готический',
            HOT_GIRL: 'Горячая Девушка',
            UNIFORM: 'Униформа',
            VAMPIRE: 'Вампир',
            WEREWOLF: 'Оборотень',
            DEMON: 'Демон',
            SUCCUBUS: 'Суккуб',
            ORC: 'Орк',
            MONSTER_GIRL: 'Девушка-Монстр',
            ROBOT: 'Робот',
            ELF: 'Эльф',
            DOUJIN: 'Додзин',
            ANIME: 'Аниме',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Рабочее Место',
            SCHOOL: 'Школа',
            FANTASY: 'Фантазия',
            URBAN: 'Городской',
            BLIND_DATE: 'Свидание Вслепую',
            DARK: 'Темный',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'ЛГБТ',
            NSFW: 'NSFW',
        },
    },
    pt: {
        loading: 'Carregando',
        pleaseWait: 'Por favor, aguarde...',
        filter: 'Filtrar',
        recommend: 'Recomendar',
        latest: 'Mais Recentes',
        male: 'Masculino',
        female: 'Feminino',
        recent: 'Recente',
        noCharactersFound: 'Nenhum Personagem Encontrado',
        adjustFilters: 'Tente ajustar seus filtros',
        adjustFiltersSuggestion: 'ou navegue por outras categorias',
        resetAll: 'Redefinir Tudo',
        noDescription: 'Sem Descrição',
        startChat: 'Iniciar Chat',
        chat: 'Chat',
        loadFailed: 'Falha ao Carregar',
        noMoreData: 'Sem Mais Dados',
        toast: {
            operationFailed: 'Operação Falhou',
        },
        time: {
            justNow: 'Agora mesmo',
            minutesAgo: 'hpa {n} min',
            hoursAgo: 'há {n} h',
            yesterday: 'Ontem',
        },
        messageType: {
            image: '[Imagem]',
            gifAnimation: '[GIF]',
            audio: '[Áudio]',
            touch3d: '[Toque 3D]',
            card: '[Cartão]',
            tip: '[Dica]',
            soul: '[Alma]',
            media: '[Mídia]',
            mateIntro: '[Intro do Mate]',
            post: '[Post]',
            novel: '[Romance]',
            sceneSwitch: '[Cena]',
        },
        genderFilter: 'Filtro de Gênero',
        interestTags: 'Tags de Interesse',
        resetFilter: 'Redefinir Filtro',
        messageList: 'Lista de Mensagens',
        recentChats: 'Chats Recentes',
        noMessages: 'Sem Mensagens',
        noChatHistory: 'Sem Histórico de Chat',
        noMoments: 'Sem Momentos',
        continue: 'Continuar',
        profile: 'Perfil',
        moments: 'Momentos',
        characterIntro: '📝 Introdução do Personagem',
        characterProfile: '🌟 Perfil do Personagem',
        characterSetting: '🌟 Configuração do Personagem',
        personality: '😇 Personalidade',
        backgroundStory: '🏰 História de Fundo',
        interests: '💖 Interesses',
        likes: '💕 Gosta',
        dislikes: '💔 Não Gosta',
        expand: 'Expandir',
        collapse: 'Recolher',
        noIntro: 'Sem Introdução',
        noMore: 'Sem Mais Dados',
        gender: 'Gênero',
        age: 'Idade',
        height: 'Altura',
        weight: 'Peso',
        tagAll: 'Todos',
        tagStepRelative: 'Parente por Afinidade',
        tagRoommate: 'Colega de Quarto',
        tagNeighbor: 'Vizinho',
        tagMarried: 'Casado',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Amor de Infância',
        tagBoss: 'Chefe',
        tagSubordinate: 'Subordinado',
        tagTeacherStudent: 'Professor/Aluno',
        tagArchEnemy: 'Arqui-Inimigo',
        tagStranger: 'Estranho',
        tagContractPartner: 'Parceiro Contratual',
        tagRichFamily: 'Família Rica',
        tagMafia: 'Máfia',
        tagDoctor: 'Médico',
        tagIdol: 'Ídolo',
        tagAssassin: 'Assassino',
        tagMaid: 'Empregada',
        tagLandlord: 'Proprietário',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Distante',
        tagShy: 'Tímido',
        tagDominant: 'Dominante',
        tagSubmissive: 'Submisso',
        tagGentle: 'Gentil',
        tagAirhead: 'Cabeça de Vento',
        tagStrict: 'Rigoroso',
        tagObsessed: 'Obcecado',
        tagScheming: 'Intrigante',
        tagPureLove: 'Amor Puro',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Curvilínea',
        tagMuscular: 'Musculoso',
        tagPetite: 'Pequena',
        tagGothic: 'Gótico',
        tagHotGirl: 'Garota Sexy',
        tagUniform: 'Uniforme',
        tagVampire: 'Vampiro',
        tagWerewolf: 'Lobisomem',
        tagDemon: 'Demônio',
        tagSuccubus: 'Súcubo',
        tagOrc: 'Orc',
        tagMonsterGirl: 'Garota Monstro',
        tagRobot: 'Robô',
        tagElf: 'Elfo',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Local de Trabalho',
        tagSchool: 'Escola',
        tagFantasy: 'Fantasia',
        tagUrban: 'Urbano',
        tagBlindDate: 'Encontro às Cegas',
        tagDark: 'Sombrio',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'Todos',
            STEP_RELATIVE: 'Parente por Afinidade',
            ROOMMATE: 'Colega de Quarto',
            NEIGHBOR: 'Vizinho',
            MARRIED: 'Casado',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Amor de Infância',
            BOSS: 'Chefe',
            SUBORDINATE: 'Subordinado',
            TEACHER_STUDENT: 'Professor/Aluno',
            ARCH_ENEMY: 'Arqui-Inimigo',
            STRANGER: 'Estranho',
            CONTRACT_PARTNER: 'Parceiro Contratual',
            RICH_FAMILY: 'Família Rica',
            MAFIA: 'Máfia',
            DOCTOR: 'Médico',
            IDOL: 'Ídolo',
            ASSASSIN: 'Assassino',
            MAID: 'Empregada',
            LANDLORD: 'Proprietário',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Distante',
            SHY: 'Tímido',
            DOMINANT: 'Dominante',
            SUBMISSIVE: 'Submisso',
            GENTLE: 'Gentil',
            AIRHEAD: 'Cabeça de Vento',
            STRICT: 'Rigoroso',
            OBSESSED: 'Obcecado',
            SCHEMING: 'Intrigante',
            PURE_LOVE: 'Amor Puro',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Curvilínea',
            MUSCULAR: 'Musculoso',
            PETITE: 'Pequena',
            GOTHIC: 'Gótico',
            HOT_GIRL: 'Garota Sexy',
            UNIFORM: 'Uniforme',
            VAMPIRE: 'Vampiro',
            WEREWOLF: 'Lobisomem',
            DEMON: 'Demônio',
            SUCCUBUS: 'Súcubo',
            ORC: 'Orc',
            MONSTER_GIRL: 'Garota Monstro',
            ROBOT: 'Robô',
            ELF: 'Elfo',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Local de Trabalho',
            SCHOOL: 'Escola',
            FANTASY: 'Fantasia',
            URBAN: 'Urbano',
            BLIND_DATE: 'Encontro às Cegas',
            DARK: 'Sombrio',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    it: {
        loading: 'Caricamento',
        pleaseWait: 'Attendere prego...',
        filter: 'Filtro',
        recommend: 'Consigliati',
        latest: 'Ultimi',
        male: 'Maschio',
        female: 'Femmina',
        recent: 'Recente',
        noCharactersFound: 'Nessun Personaggio Trovato',
        adjustFilters: 'Prova ad aggiustare i filtri',
        adjustFiltersSuggestion: 'o esplora altre categorie',
        resetAll: 'Ripristina Tutto',
        noDescription: 'Nessuna Descrizione',
        startChat: 'Inizia Chat',
        chat: 'Chat',
        loadFailed: 'Caricamento Fallito',
        noMoreData: 'Nessun Altro Dato',
        toast: {
            operationFailed: 'Operazione Fallita',
        },
        time: {
            justNow: 'Adesso',
            minutesAgo: '{n} min fa',
            hoursAgo: '{n} ore fa',
            yesterday: 'Ieri',
        },
        messageType: {
            image: '[Immagine]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[Tocco 3D]',
            card: '[Scheda]',
            tip: '[Suggerimento]',
            soul: '[Anima]',
            media: '[Media]',
            mateIntro: '[Intro Mate]',
            post: '[Post]',
            novel: '[Romanzo]',
            sceneSwitch: '[Scena]',
        },
        genderFilter: 'Genere',
        interestTags: 'Tag',
        resetFilter: 'Ripristina Filtro',
        messageList: 'Elenco Messaggi',
        recentChats: 'Chat Recenti',
        noMessages: 'Nessun Messaggio',
        noChatHistory: 'Nessuna Cronologia Chat',
        noMoments: 'Nessun Momento',
        continue: 'Continua',
        profile: 'Profilo',
        moments: 'Momenti',
        characterIntro: '📝 Introduzione al Personaggio',
        characterProfile: '🌟 Profilo del Personaggio',
        characterSetting: '🌟 Impostazione del Personaggio',
        personality: '😇 Personalità',
        backgroundStory: '🏰 Storia di Sfondo',
        interests: '💖 Interessi',
        likes: '💕 Piace',
        dislikes: '💔 Non Piace',
        expand: 'Espandi',
        collapse: 'Riduci',
        noIntro: 'Nessuna Introduzione',
        noMore: 'Nessun Altro Dato',
        gender: 'Genere',
        age: 'Età',
        height: 'Altezza',
        weight: 'Peso',
        tagAll: 'TUTTI',
        tagStepRelative: 'Parente Acquisito',
        tagRoommate: 'Coinquilino',
        tagNeighbor: 'Vicino',
        tagMarried: 'Sposato',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Amore d\'Infanzia',
        tagBoss: 'Capo',
        tagSubordinate: 'Subordinato',
        tagTeacherStudent: 'Insegnante/Studente',
        tagArchEnemy: 'Arcinemico',
        tagStranger: 'Sconosciuto',
        tagContractPartner: 'Partner Contrattuale',
        tagRichFamily: 'Famiglia Ricca',
        tagMafia: 'Mafia',
        tagDoctor: 'Dottore',
        tagIdol: 'Idolo',
        tagAssassin: 'Assassino',
        tagMaid: 'Cameriera',
        tagLandlord: 'Proprietario',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Distaccato',
        tagShy: 'Timido',
        tagDominant: 'Dominante',
        tagSubmissive: 'Sottomesso',
        tagGentle: 'Gentile',
        tagAirhead: 'Testa di Rapa',
        tagStrict: 'Rigoroso',
        tagObsessed: 'Ossessionato',
        tagScheming: 'Intrigante',
        tagPureLove: 'Amore Puro',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Formosa',
        tagMuscular: 'Muscoloso',
        tagPetite: 'Minuta',
        tagGothic: 'Gotico',
        tagHotGirl: 'Ragazza Sexy',
        tagUniform: 'Uniforme',
        tagVampire: 'Vampiro',
        tagWerewolf: 'Licantropo',
        tagDemon: 'Demone',
        tagSuccubus: 'Succube',
        tagOrc: 'Orco',
        tagMonsterGirl: 'Ragazza Mostro',
        tagRobot: 'Robot',
        tagElf: 'Elfo',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Lavoro',
        tagSchool: 'Scuola',
        tagFantasy: 'Fantasia',
        tagUrban: 'Urbano',
        tagBlindDate: 'Appuntamento al Buio',
        tagDark: 'Oscuro',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'TUTTI',
            STEP_RELATIVE: 'Parente Acquisito',
            ROOMMATE: 'Coinquilino',
            NEIGHBOR: 'Vicino',
            MARRIED: 'Sposato',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Amore d\'Infanzia',
            BOSS: 'Capo',
            SUBORDINATE: 'Subordinato',
            TEACHER_STUDENT: 'Insegnante/Studente',
            ARCH_ENEMY: 'Arcinemico',
            STRANGER: 'Sconosciuto',
            CONTRACT_PARTNER: 'Partner Contrattuale',
            RICH_FAMILY: 'Famiglia Ricca',
            MAFIA: 'Mafia',
            DOCTOR: 'Dottore',
            IDOL: 'Idolo',
            ASSASSIN: 'Assassino',
            MAID: 'Cameriera',
            LANDLORD: 'Proprietario',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Distaccato',
            SHY: 'Timido',
            DOMINANT: 'Dominante',
            SUBMISSIVE: 'Sottomesso',
            GENTLE: 'Gentile',
            AIRHEAD: 'Testa di Rapa',
            STRICT: 'Rigoroso',
            OBSESSED: 'Ossessionato',
            SCHEMING: 'Intrigante',
            PURE_LOVE: 'Amore Puro',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Formosa',
            MUSCULAR: 'Muscoloso',
            PETITE: 'Minuta',
            GOTHIC: 'Gotico',
            HOT_GIRL: 'Ragazza Sexy',
            UNIFORM: 'Uniforme',
            VAMPIRE: 'Vampiro',
            WEREWOLF: 'Licantropo',
            DEMON: 'Demone',
            SUCCUBUS: 'Succube',
            ORC: 'Orco',
            MONSTER_GIRL: 'Ragazza Mostro',
            ROBOT: 'Robot',
            ELF: 'Elfo',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Lavoro',
            SCHOOL: 'Scuola',
            FANTASY: 'Fantasia',
            URBAN: 'Urbano',
            BLIND_DATE: 'Appuntamento al Buio',
            DARK: 'Oscuro',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    ar: {
        loading: 'جار التحميل',
        pleaseWait: 'يرجى الانتظار...',
        filter: 'تصفية',
        recommend: 'موصى به',
        latest: 'الأحدث',
        male: 'ذكر',
        female: 'أنثى',
        recent: 'الأخيرة',
        noCharactersFound: 'لم يتم العثور على شخصيات',
        adjustFilters: 'حاول ضبط المرشحات',
        adjustFiltersSuggestion: 'أو تصفح فئات أخرى',
        resetAll: 'إعادة تعيين الكل',
        noDescription: 'لا يوجد وصف',
        startChat: 'بدء المحادثة',
        chat: 'الدردشة',
        loadFailed: 'فشل التحميل',
        noMoreData: 'لا مزيد من البيانات',
        toast: {
            operationFailed: 'فشلت العملية',
        },
        time: {
            justNow: 'الآن',
            minutesAgo: 'منذ دقائق',
            hoursAgo: 'منذ ساعات',
            yesterday: 'أمس',
        },
        messageType: {
            image: '[صورة]',
            gifAnimation: '[GIF]',
            audio: '[صوت]',
            touch3d: '[لمسة ثلاثية الأبعاد]',
            card: '[بطاقة]',
            tip: '[نصيحة]',
            soul: '[روح]',
            media: '[وسائط]',
            mateIntro: '[مقدمة الزميل]',
            post: '[منشور]',
            novel: '[رواية]',
            sceneSwitch: '[مشهد]',
        },
        genderFilter: 'الجنس',
        interestTags: 'علامات الاهتمام',
        resetFilter: 'إعادة تعيين الفلتر',
        messageList: 'قائمة الرسائل',
        recentChats: 'المحادثات الأخيرة',
        noMessages: 'لا توجد رسائل',
        noChatHistory: 'لا يوجد سجل محادثات',
        noMoments: 'لا توجد لحظات',
        continue: 'متابعة',
        profile: 'الملف الشخصي',
        moments: 'اللحظات',
        characterIntro: '📝 مقدمة الشخصية',
        characterProfile: '🌟 ملف الشخصية',
        characterSetting: '🌟 إعداد الشخصية',
        personality: '😇 الشخصية',
        backgroundStory: '🏰 القصة الخلفية',
        interests: '💖 الاهتمامات',
        likes: '💕 يحب',
        dislikes: '💔 لا يحب',
        expand: 'توسيع',
        collapse: 'طي',
        noIntro: 'لا توجد مقدمة',
        noMore: 'لا مزيد من البيانات',
        gender: 'الجنس',
        age: 'العمر',
        height: 'الطول',
        weight: 'الوزن',
        tagAll: 'الكل',
        tagStepRelative: 'قريب بالزواج',
        tagRoommate: 'زميل الغرفة',
        tagNeighbor: 'جار',
        tagMarried: 'متزوج',
        tagEx: 'السابق',
        tagChildhoodSweetheart: 'حب الطفولة',
        tagBoss: 'رئيس',
        tagSubordinate: 'مرؤوس',
        tagTeacherStudent: 'معلم/طالب',
        tagArchEnemy: 'العدو اللدود',
        tagStranger: 'غريب',
        tagContractPartner: 'شريك تعاقدي',
        tagRichFamily: 'عائلة غنية',
        tagMafia: 'مافيا',
        tagDoctor: 'طبيب',
        tagIdol: 'أيدول',
        tagAssassin: 'قاتل',
        tagMaid: 'خادمة',
        tagLandlord: 'مالك العقار',
        tagYandere: 'ياندري',
        tagTsundere: 'تسوندري',
        tagAloof: 'بارد',
        tagShy: 'خجول',
        tagDominant: 'مهيمن',
        tagSubmissive: 'خاضع',
        tagGentle: 'لطيف',
        tagAirhead: 'ساذج',
        tagStrict: 'صارم',
        tagObsessed: 'مهووس',
        tagScheming: 'ماكر',
        tagPureLove: 'حب نقي',
        tagMilf: 'امرأة ناضجة',
        tagDilf: 'رجل ناضج',
        tagCurvy: 'ممتلئة',
        tagMuscular: 'عضلي',
        tagPetite: 'صغيرة',
        tagGothic: 'قوطي',
        tagHotGirl: 'فتاة مثيرة',
        tagUniform: 'زي موحد',
        tagVampire: 'مصاص دماء',
        tagWerewolf: 'إنسان ذئب',
        tagDemon: 'شيطان',
        tagSuccubus: 'سكيوبوس',
        tagOrc: 'أورك',
        tagMonsterGirl: 'فتاة وحش',
        tagRobot: 'روبوت',
        tagElf: 'قزم',
        tagDoujin: 'دوجين',
        tagAnime: 'أنمي',
        tagTwoDimensional: 'ثنائي الأبعاد',
        tagWorkplace: 'مكان العمل',
        tagSchool: 'مدرسة',
        tagFantasy: 'خيال',
        tagUrban: 'حضري',
        tagBlindDate: 'موعد أعمى',
        tagDark: 'مظلم',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'الكل',
            STEP_RELATIVE: 'قريب بالزواج',
            ROOMMATE: 'زميل الغرفة',
            NEIGHBOR: 'جار',
            MARRIED: 'متزوج',
            EX: 'السابق',
            CHILDHOOD_SWEETHEART: 'حب الطفولة',
            BOSS: 'رئيس',
            SUBORDINATE: 'مرؤوس',
            TEACHER_STUDENT: 'معلم/طالب',
            ARCH_ENEMY: 'العدو اللدود',
            STRANGER: 'غريب',
            CONTRACT_PARTNER: 'شريك تعاقدي',
            RICH_FAMILY: 'عائلة غنية',
            MAFIA: 'مافيا',
            DOCTOR: 'طبيب',
            IDOL: 'أيدول',
            ASSASSIN: 'قاتل',
            MAID: 'خادمة',
            LANDLORD: 'مالك العقار',
            YANDERE: 'ياندري',
            TSUNDERE: 'تسوندري',
            ALOOF: 'بارد',
            SHY: 'خجول',
            DOMINANT: 'مهيمن',
            SUBMISSIVE: 'خاضع',
            GENTLE: 'لطيف',
            AIRHEAD: 'ساذج',
            STRICT: 'صارم',
            OBSESSED: 'مهووس',
            SCHEMING: 'ماكر',
            PURE_LOVE: 'حب نقي',
            MILF: 'امرأة ناضجة',
            DILF: 'رجل ناضج',
            CURVY: 'ممتلئة',
            MUSCULAR: 'عضلي',
            PETITE: 'صغيرة',
            GOTHIC: 'قوطي',
            HOT_GIRL: 'فتاة مثيرة',
            UNIFORM: 'زي موحد',
            VAMPIRE: 'مصاص دماء',
            WEREWOLF: 'إنسان ذئب',
            DEMON: 'شيطان',
            SUCCUBUS: 'سكيوبوس',
            ORC: 'أورك',
            MONSTER_GIRL: 'فتاة وحش',
            ROBOT: 'روبوت',
            ELF: 'قزم',
            DOUJIN: 'دوجين',
            ANIME: 'أنمي',
            TWO_DIMENSIONAL: 'ثنائي الأبعاد',
            WORKPLACE: 'مكان العمل',
            SCHOOL: 'مدرسة',
            FANTASY: 'خيال',
            URBAN: 'حضري',
            BLIND_DATE: 'موعد أعمى',
            DARK: 'مظلم',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    th: {
        // Basic UI for list page
        loading: 'กำลังโหลด',
        pleaseWait: 'โปรดรอสักครู่...',
        filter: 'ตัวกรอง',
        recommend: 'แนะนำ',
        latest: 'ล่าสุด',
        male: 'ผู้ชาย',
        female: 'ผู้หญิง',
        recent: 'ล่าสุดที่ดู',
        
        // Empty states
        noCharactersFound: 'ไม่พบตัวละคร',
        adjustFilters: 'ลองปรับตัวกรองของคุณ',
        adjustFiltersSuggestion: 'หรือเลือกดูหมวดอื่นๆ',
        resetAll: 'รีเซ็ตทั้งหมด',
        noDescription: 'ไม่มีคำอธิบาย',
        
        // Actions
        startChat: 'เริ่มแชต',
        chat: 'แชต',
        // Loading states
        loadFailed: 'โหลดไม่สำเร็จ',
        noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
        
        // Toast messages
        toast: {
            operationFailed: 'ดำเนินการไม่สำเร็จ',
            },
            time: 'time',
            messageType: 'messageType',
            genderFilter: 'genderFilter',
            interestTags: 'interestTags',
            resetFilter: 'resetFilter',
            messageList: 'messageList',
            recentChats: 'recentChats',
            noMessages: 'noMessages',
            noChatHistory: 'noChatHistory',
            noMoments: 'noMoments',
            continue: 'continue',
            profile: 'profile',
            moments: 'moments',
            characterIntro: 'characterIntro',
            characterProfile: 'characterProfile',
            characterSetting: 'characterSetting',
            personality: 'personality',
            backgroundStory: 'backgroundStory',
            interests: 'interests',
            likes: 'likes',
            dislikes: 'dislikes',
            expand: 'expand',
            collapse: 'collapse',
            noIntro: 'noIntro',
            noMore: 'noMore',
            gender: 'gender',
            age: 'age',
            height: 'height',
            weight: 'weight',
            tagAll: 'tagAll',
            tagStepRelative: 'tagStepRelative',
            tagRoommate: 'tagRoommate',
            tagNeighbor: 'tagNeighbor',
            tagMarried: 'tagMarried',
            tagEx: 'tagEx',
            tagChildhoodSweetheart: 'tagChildhoodSweetheart',
            tagBoss: 'tagBoss',
            tagSubordinate: 'tagSubordinate',
            tagTeacherStudent: 'tagTeacherStudent',
            tagArchEnemy: 'tagArchEnemy',
            tagStranger: 'tagStranger',
            tagContractPartner: 'tagContractPartner',
            tagRichFamily: 'tagRichFamily',
            tagMafia: 'tagMafia',
            tagDoctor: 'tagDoctor',
            tagIdol: 'tagIdol',
            tagAssassin: 'tagAssassin',
            tagMaid: 'tagMaid',
            tagLandlord: 'tagLandlord',
            tagYandere: 'tagYandere',
            tagTsundere: 'tagTsundere',
            tagAloof: 'tagAloof',
            tagShy: 'tagShy',
            tagDominant: 'tagDominant',
            tagSubmissive: 'tagSubmissive',
            tagGentle: 'tagGentle',
            tagAirhead: 'tagAirhead',
            tagStrict: 'tagStrict',
            tagObsessed: 'tagObsessed',
            tagScheming: 'tagScheming',
            tagPureLove: 'tagPureLove',
            tagMilf: 'tagMilf',
            tagDilf: 'tagDilf',
            tagCurvy: 'tagCurvy',
            tagMuscular: 'tagMuscular',
            tagPetite: 'tagPetite',
            tagGothic: 'tagGothic',
            tagHotGirl: 'tagHotGirl',
            tagUniform: 'tagUniform',
            tagVampire: 'tagVampire',
            tagWerewolf: 'tagWerewolf',
            tagDemon: 'tagDemon',
            tagSuccubus: 'tagSuccubus',
            tagOrc: 'tagOrc',
            tagMonsterGirl: 'tagMonsterGirl',
            tagRobot: 'tagRobot',
            tagElf: 'tagElf',
            tagDoujin: 'tagDoujin',
            tagAnime: 'tagAnime',
            tagTwoDimensional: 'tagTwoDimensional',
            tagWorkplace: 'tagWorkplace',
            tagSchool: 'tagSchool',
            tagFantasy: 'tagFantasy',
            tagUrban: 'tagUrban',
            tagBlindDate: 'tagBlindDate',
            tagDark: 'tagDark',
            tagBoysLove: 'tagBoysLove',
            tagGirlsLove: 'tagGirlsLove',
            tagLgbt: 'tagLgbt',
            tagNsfw: 'tagNsfw',
            tags: 'tags',
    },
    da: {
        // Grundlæggende UI for listeside
        loading: 'Indlæser',
        pleaseWait: 'Vent venligst...',
        filter: 'Filter',
        recommend: 'Anbefalet',
        latest: 'Nyeste',
        male: 'Mand',
        female: 'Kvinde',
        recent: 'Seneste',
        
        // Tomme tilstande
        noCharactersFound: 'Ingen karakterer fundet',
        adjustFilters: 'Prøv at justere dine filtre',
        adjustFiltersSuggestion: 'eller gennemse andre kategorier',
        resetAll: 'Nulstil alle',
        noDescription: 'Ingen beskrivelse',
        
        // Handlinger
        startChat: 'Start chat',
        chat: 'Chat',
        // Indlæsningstilstande
        loadFailed: 'Indlæsning mislykkedes',
        noMoreData: 'Ingen flere data',
        
        // Toast beskeder
        toast: {
            operationFailed: 'Handling mislykkedes',
            },
        
        // Tidsformatering
        time: {
            justNow: 'Lige nu',
            minutesAgo: 'min siden',
            hoursAgo: 'timer siden',
            yesterday: 'I går',
        },
        
        // Beskedtyper
        messageType: {
            image: '[Billede]',
            gifAnimation: '[GIF]',
            audio: '[Lyd]',
            touch3d: '[3D Touch]',
            card: '[Kort]',
            tip: '[Tip]',
            soul: '[Sjæl]',
            media: '[Medie]',
            mateIntro: '[Partner intro]',
            post: '[Opslag]',
            novel: '[Roman]',
            sceneSwitch: '[Scene]',
        },
        
        // Filter relateret
        genderFilter: 'Køn',
        interestTags: 'Interesser',
        resetFilter: 'Nulstil filter',
        
        // Chatliste
        messageList: 'Beskedliste',
        recentChats: 'Seneste chats',
        noMessages: 'Ingen beskeder',
        noChatHistory: 'Ingen chathistorik',
        noMoments: 'Ingen øjeblikke',
        continue: 'Fortsæt',
        
        // Detaljeside faner
        profile: 'Profil',
        moments: 'Øjeblikke',
        characterIntro: '📝 Karakter intro',
        characterProfile: '🌟 Karakter profil',
        characterSetting: '🌟 Karakter indstilling',
        personality: '😇 Personlighed',
        backgroundStory: '🏰 Baggrundshistorie',
        interests: '💖 Interesser',
        likes: '💕 Synes godt om',
        dislikes: '💔 Kan ikke lide',
        expand: 'Udvid',
        collapse: 'Kollaps',
        noIntro: 'Ingen introduktion',
        noMore: 'Ikke mere',
        
        // Info etiketter
        gender: 'Køn',
        age: 'Alder',
        height: 'Højde',
        weight: 'Vægt',
        
        // Tags - til index.vue (tagXXX format)
        tagAll: 'ALLE',
        tagStepRelative: 'Stedfamilie',
        tagRoommate: 'Roommate',
        tagNeighbor: 'Nabo',
        tagMarried: 'Gift',
        tagEx: 'Eks',
        tagChildhoodSweetheart: 'Barndomskærlighed',
        tagBoss: 'Chef',
        tagSubordinate: 'Underordnet',
        tagTeacherStudent: 'Lærer/Elev',
        tagArchEnemy: 'Ærkefjende',
        tagStranger: 'Fremmed',
        tagContractPartner: 'Kontraktpartner',
        tagRichFamily: 'Rig familie',
        tagMafia: 'Mafia',
        tagDoctor: 'Læge',
        tagIdol: 'Idol',
        tagAssassin: 'Snigmorder',
        tagMaid: 'Stuepige',
        tagLandlord: 'Udlejer',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Reserveret',
        tagShy: 'Genert',
        tagDominant: 'Dominerende',
        tagSubmissive: 'Underdanig',
        tagGentle: 'Blid',
        tagAirhead: 'Forvirret',
        tagStrict: 'Streng',
        tagObsessed: 'Besat',
        tagScheming: 'Intrigant',
        tagPureLove: 'Ren kærlighed',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Kurvet',
        tagMuscular: 'Muskuløs',
        tagPetite: 'Petit',
        tagGothic: 'Gotisk',
        tagHotGirl: 'Hot pige',
        tagUniform: 'Uniform',
        tagVampire: 'Vampyr',
        tagWerewolf: 'Varulv',
        tagDemon: 'Dæmon',
        tagSuccubus: 'Succubus',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Monster pige',
        tagRobot: 'Robot',
        tagElf: 'Elver',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Arbejdsplads',
        tagSchool: 'Skole',
        tagFantasy: 'Fantasi',
        tagUrban: 'Urban',
        tagBlindDate: 'Blinddate',
        tagDark: 'Mørk',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALLE',
            STEP_RELATIVE: 'Stedfamilie',
            ROOMMATE: 'Roommate',
            NEIGHBOR: 'Nabo',
            MARRIED: 'Gift',
            EX: 'Eks',
            CHILDHOOD_SWEETHEART: 'Barndomskærlighed',
            BOSS: 'Chef',
            SUBORDINATE: 'Underordnet',
            TEACHER_STUDENT: 'Lærer/Elev',
            ARCH_ENEMY: 'Ærkefjende',
            STRANGER: 'Fremmed',
            CONTRACT_PARTNER: 'Kontraktpartner',
            RICH_FAMILY: 'Rig familie',
            MAFIA: 'Mafia',
            DOCTOR: 'Læge',
            IDOL: 'Idol',
            ASSASSIN: 'Snigmorder',
            MAID: 'Stuepige',
            LANDLORD: 'Udlejer',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Reserveret',
            SHY: 'Genert',
            DOMINANT: 'Dominerende',
            SUBMISSIVE: 'Underdanig',
            GENTLE: 'Blid',
            AIRHEAD: 'Forvirret',
            STRICT: 'Streng',
            OBSESSED: 'Besat',
            SCHEMING: 'Intrigant',
            PURE_LOVE: 'Ren kærlighed',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Kurvet',
            MUSCULAR: 'Muskuløs',
            PETITE: 'Petit',
            GOTHIC: 'Gotisk',
            HOT_GIRL: 'Hot pige',
            UNIFORM: 'Uniform',
            VAMPIRE: 'Vampyr',
            WEREWOLF: 'Varulv',
            DEMON: 'Dæmon',
            SUCCUBUS: 'Succubus',
            ORC: 'Ork',
            MONSTER_GIRL: 'Monster pige',
            ROBOT: 'Robot',
            ELF: 'Elver',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Arbejdsplads',
            SCHOOL: 'Skole',
            FANTASY: 'Fantasi',
            URBAN: 'Urban',
            BLIND_DATE: 'Blinddate',
            DARK: 'Mørk',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    no: {
        // Grunnleggende UI for listeside
        loading: 'Laster',
        pleaseWait: 'Vennligst vent...',
        filter: 'Filter',
        recommend: 'Anbefalt',
        latest: 'Nyeste',
        male: 'Mann',
        female: 'Kvinne',
        recent: 'Nylig',
        
        // Tomme tilstander
        noCharactersFound: 'Ingen karakterer funnet',
        adjustFilters: 'Prøv å justere filtrene',
        adjustFiltersSuggestion: 'eller bla i andre kategorier',
        resetAll: 'Tilbakestill alt',
        noDescription: 'Ingen beskrivelse',
        
        // Handlinger
        startChat: 'Start chat',
        chat: 'Chat',
        // Lastetilstander
        loadFailed: 'Lasting mislyktes',
        noMoreData: 'Ingen flere data',
        
        // Toast meldinger
        toast: {
            operationFailed: 'Handling mislyktes',
            },
        
        // Tidsformatering
        time: {
            justNow: 'Akkurat nå',
            minutesAgo: 'min siden',
            hoursAgo: 'timer siden',
            yesterday: 'I går',
        },
        
        // Meldingstyper
        messageType: {
            image: '[Bilde]',
            gifAnimation: '[GIF]',
            audio: '[Lyd]',
            touch3d: '[3D Touch]',
            card: '[Kort]',
            tip: '[Tips]',
            soul: '[Sjel]',
            media: '[Media]',
            mateIntro: '[Partner intro]',
            post: '[Innlegg]',
            novel: '[Roman]',
            sceneSwitch: '[Scene]',
        },
        
        // Filter relatert
        genderFilter: 'Kjønn',
        interestTags: 'Interesser',
        resetFilter: 'Tilbakestill filter',
        
        // Chatliste
        messageList: 'Meldingsliste',
        recentChats: 'Nylige chatter',
        noMessages: 'Ingen meldinger',
        noChatHistory: 'Ingen chathistorikk',
        noMoments: 'Ingen øyeblikk',
        continue: 'Fortsett',
        
        // Detaljeside faner
        profile: 'Profil',
        moments: 'Øyeblikk',
        characterIntro: '📝 Karakter intro',
        characterProfile: '🌟 Karakter profil',
        characterSetting: '🌟 Karakter innstilling',
        personality: '😇 Personlighet',
        backgroundStory: '🏰 Bakgrunnshistorie',
        interests: '💖 Interesser',
        likes: '💕 Liker',
        dislikes: '💔 Misliker',
        expand: 'Utvid',
        collapse: 'Kollaps',
        noIntro: 'Ingen introduksjon',
        noMore: 'Ikke mer',
        
        // Info etiketter
        gender: 'Kjønn',
        age: 'Alder',
        height: 'Høyde',
        weight: 'Vekt',
        
        // Tags - for index.vue (tagXXX format)
        tagAll: 'ALLE',
        tagStepRelative: 'Stefamilie',
        tagRoommate: 'Romkamerat',
        tagNeighbor: 'Nabo',
        tagMarried: 'Gift',
        tagEx: 'Eks',
        tagChildhoodSweetheart: 'Barndomskjærlighet',
        tagBoss: 'Sjef',
        tagSubordinate: 'Underordnet',
        tagTeacherStudent: 'Lærer/Elev',
        tagArchEnemy: 'Erkefiende',
        tagStranger: 'Fremmed',
        tagContractPartner: 'Kontraktspartner',
        tagRichFamily: 'Rik familie',
        tagMafia: 'Mafia',
        tagDoctor: 'Lege',
        tagIdol: 'Idol',
        tagAssassin: 'Snikmorder',
        tagMaid: 'Hushjelp',
        tagLandlord: 'Utleier',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Reservert',
        tagShy: 'Sjenert',
        tagDominant: 'Dominerende',
        tagSubmissive: 'Underdanig',
        tagGentle: 'Mild',
        tagAirhead: 'Forvirret',
        tagStrict: 'Streng',
        tagObsessed: 'Besatt',
        tagScheming: 'Intrigant',
        tagPureLove: 'Ren kjærlighet',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Kurvet',
        tagMuscular: 'Muskuløs',
        tagPetite: 'Petit',
        tagGothic: 'Gotisk',
        tagHotGirl: 'Hot jente',
        tagUniform: 'Uniform',
        tagVampire: 'Vampyr',
        tagWerewolf: 'Varulv',
        tagDemon: 'Demon',
        tagSuccubus: 'Succubus',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Monster jente',
        tagRobot: 'Robot',
        tagElf: 'Alv',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Arbeidsplass',
        tagSchool: 'Skole',
        tagFantasy: 'Fantasi',
        tagUrban: 'Urban',
        tagBlindDate: 'Blinddate',
        tagDark: 'Mørk',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALLE',
            STEP_RELATIVE: 'Stefamilie',
            ROOMMATE: 'Romkamerat',
            NEIGHBOR: 'Nabo',
            MARRIED: 'Gift',
            EX: 'Eks',
            CHILDHOOD_SWEETHEART: 'Barndomskjærlighet',
            BOSS: 'Sjef',
            SUBORDINATE: 'Underordnet',
            TEACHER_STUDENT: 'Lærer/Elev',
            ARCH_ENEMY: 'Erkefiende',
            STRANGER: 'Fremmed',
            CONTRACT_PARTNER: 'Kontraktspartner',
            RICH_FAMILY: 'Rik familie',
            MAFIA: 'Mafia',
            DOCTOR: 'Lege',
            IDOL: 'Idol',
            ASSASSIN: 'Snikmorder',
            MAID: 'Hushjelp',
            LANDLORD: 'Utleier',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Reservert',
            SHY: 'Sjenert',
            DOMINANT: 'Dominerende',
            SUBMISSIVE: 'Underdanig',
            GENTLE: 'Mild',
            AIRHEAD: 'Forvirret',
            STRICT: 'Streng',
            OBSESSED: 'Besatt',
            SCHEMING: 'Intrigant',
            PURE_LOVE: 'Ren kjærlighet',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Kurvet',
            MUSCULAR: 'Muskuløs',
            PETITE: 'Petit',
            GOTHIC: 'Gotisk',
            HOT_GIRL: 'Hot jente',
            UNIFORM: 'Uniform',
            VAMPIRE: 'Vampyr',
            WEREWOLF: 'Varulv',
            DEMON: 'Demon',
            SUCCUBUS: 'Succubus',
            ORC: 'Ork',
            MONSTER_GIRL: 'Monster jente',
            ROBOT: 'Robot',
            ELF: 'Alv',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Arbeidsplass',
            SCHOOL: 'Skole',
            FANTASY: 'Fantasi',
            URBAN: 'Urban',
            BLIND_DATE: 'Blinddate',
            DARK: 'Mørk',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    nl: {
        // Basis UI voor lijstpagina
        loading: 'Laden',
        pleaseWait: 'Even geduld...',
        filter: 'Filter',
        recommend: 'Aanbevolen',
        latest: 'Nieuwste',
        male: 'Man',
        female: 'Vrouw',
        recent: 'Recent',
        
        // Lege staten
        noCharactersFound: 'Geen personages gevonden',
        adjustFilters: 'Probeer je filters aan te passen',
        adjustFiltersSuggestion: 'of bekijk andere categorieën',
        resetAll: 'Alles resetten',
        noDescription: 'Geen beschrijving',
        
        // Acties
        startChat: 'Chat starten',
        chat: 'Chat',
        // Laadstaten
        loadFailed: 'Laden mislukt',
        noMoreData: 'Geen verdere gegevens',
        
        // Toast berichten
        toast: {
            operationFailed: 'Actie mislukt',
            },
        
        // Tijdformaat
        time: {
            justNow: 'Zojuist',
            minutesAgo: 'min geleden',
            hoursAgo: 'uur geleden',
            yesterday: 'Gisteren',
        },
        
        // Berichttypen
        messageType: {
            image: '[Afbeelding]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Kaart]',
            tip: '[Tip]',
            soul: '[Ziel]',
            media: '[Media]',
            mateIntro: '[Partner intro]',
            post: '[Post]',
            novel: '[Roman]',
            sceneSwitch: '[Scène]',
        },
        
        // Filter gerelateerd
        genderFilter: 'Geslacht',
        interestTags: 'Interesses',
        resetFilter: 'Filter resetten',
        
        // Chatlijst
        messageList: 'Berichtenlijst',
        recentChats: 'Recente chats',
        noMessages: 'Geen berichten',
        noChatHistory: 'Geen chatgeschiedenis',
        noMoments: 'Geen momenten',
        continue: 'Doorgaan',
        
        // Detailpagina tabs
        profile: 'Profiel',
        moments: 'Momenten',
        characterIntro: '📝 Karakter intro',
        characterProfile: '🌟 Karakter profiel',
        characterSetting: '🌟 Karakter instelling',
        personality: '😇 Persoonlijkheid',
        backgroundStory: '🏰 Achtergrondverhaal',
        interests: '💖 Interesses',
        likes: '💕 Houdt van',
        dislikes: '💔 Houdt niet van',
        expand: 'Uitvouwen',
        collapse: 'Invouwen',
        noIntro: 'Geen introductie',
        noMore: 'Niet meer',
        
        // Info labels
        gender: 'Geslacht',
        age: 'Leeftijd',
        height: 'Lengte',
        weight: 'Gewicht',
        
        // Tags - voor index.vue (tagXXX formaat)
        tagAll: 'ALLE',
        tagStepRelative: 'Stieffamilie',
        tagRoommate: 'Huisgenoot',
        tagNeighbor: 'Buur',
        tagMarried: 'Getrouwd',
        tagEx: 'Ex',
        tagChildhoodSweetheart: 'Jeugdliefde',
        tagBoss: 'Baas',
        tagSubordinate: 'Ondergeschikte',
        tagTeacherStudent: 'Leraar/Leerling',
        tagArchEnemy: 'Aartsvijand',
        tagStranger: 'Vreemde',
        tagContractPartner: 'Contractpartner',
        tagRichFamily: 'Rijke familie',
        tagMafia: 'Maffia',
        tagDoctor: 'Dokter',
        tagIdol: 'Idool',
        tagAssassin: 'Moordenaar',
        tagMaid: 'Dienstmeisje',
        tagLandlord: 'Verhuurder',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Afstandelijk',
        tagShy: 'Verlegen',
        tagDominant: 'Dominant',
        tagSubmissive: 'Onderdanig',
        tagGentle: 'Zacht',
        tagAirhead: 'Verward',
        tagStrict: 'Streng',
        tagObsessed: 'Geobsedeerd',
        tagScheming: 'Intrigerend',
        tagPureLove: 'Pure liefde',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Curvy',
        tagMuscular: 'Gespierd',
        tagPetite: 'Petite',
        tagGothic: 'Gothic',
        tagHotGirl: 'Hot meisje',
        tagUniform: 'Uniform',
        tagVampire: 'Vampier',
        tagWerewolf: 'Weerwolf',
        tagDemon: 'Demon',
        tagSuccubus: 'Succubus',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Monster meisje',
        tagRobot: 'Robot',
        tagElf: 'Elf',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Werkplek',
        tagSchool: 'School',
        tagFantasy: 'Fantasie',
        tagUrban: 'Stedelijk',
        tagBlindDate: 'Blind date',
        tagDark: 'Donker',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tags
        tags: {
            ALL: 'ALLE',
            STEP_RELATIVE: 'Stieffamilie',
            ROOMMATE: 'Huisgenoot',
            NEIGHBOR: 'Buur',
            MARRIED: 'Getrouwd',
            EX: 'Ex',
            CHILDHOOD_SWEETHEART: 'Jeugdliefde',
            BOSS: 'Baas',
            SUBORDINATE: 'Ondergeschikte',
            TEACHER_STUDENT: 'Leraar/Leerling',
            ARCH_ENEMY: 'Aartsvijand',
            STRANGER: 'Vreemde',
            CONTRACT_PARTNER: 'Contractpartner',
            RICH_FAMILY: 'Rijke familie',
            MAFIA: 'Maffia',
            DOCTOR: 'Dokter',
            IDOL: 'Idool',
            ASSASSIN: 'Moordenaar',
            MAID: 'Dienstmeisje',
            LANDLORD: 'Verhuurder',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Afstandelijk',
            SHY: 'Verlegen',
            DOMINANT: 'Dominant',
            SUBMISSIVE: 'Onderdanig',
            GENTLE: 'Zacht',
            AIRHEAD: 'Verward',
            STRICT: 'Streng',
            OBSESSED: 'Geobsedeerd',
            SCHEMING: 'Intrigerend',
            PURE_LOVE: 'Pure liefde',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Curvy',
            MUSCULAR: 'Gespierd',
            PETITE: 'Petite',
            GOTHIC: 'Gothic',
            HOT_GIRL: 'Hot meisje',
            UNIFORM: 'Uniform',
            VAMPIRE: 'Vampier',
            WEREWOLF: 'Weerwolf',
            DEMON: 'Demon',
            SUCCUBUS: 'Succubus',
            ORC: 'Ork',
            MONSTER_GIRL: 'Monster meisje',
            ROBOT: 'Robot',
            ELF: 'Elf',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Werkplek',
            SCHOOL: 'School',
            FANTASY: 'Fantasie',
            URBAN: 'Stedelijk',
            BLIND_DATE: 'Blind date',
            DARK: 'Donker',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    id: {
        // UI dasar untuk halaman daftar
        loading: 'Memuat',
        pleaseWait: 'Harap tunggu...',
        filter: 'Filter',
        recommend: 'Direkomendasikan',
        latest: 'Terbaru',
        male: 'Pria',
        female: 'Wanita',
        recent: 'Terbaru',
        
        // Status kosong
        noCharactersFound: 'Tidak ada karakter ditemukan',
        adjustFilters: 'Coba sesuaikan filter Anda',
        adjustFiltersSuggestion: 'atau telusuri kategori lain',
        resetAll: 'Atur ulang semua',
        noDescription: 'Tidak ada deskripsi',
        
        // Aksi
        startChat: 'Mulai chat',
        chat: 'Chat',
        // Status pemuatan
        loadFailed: 'Gagal memuat',
        noMoreData: 'Tidak ada data lagi',
        
        // Pesan Toast
        toast: {
            operationFailed: 'Operasi gagal',
            },
        
        // Format waktu
        time: {
            justNow: 'Baru saja',
            minutesAgo: 'menit lalu',
            hoursAgo: 'jam lalu',
            yesterday: 'Kemarin',
        },
        
        // Jenis pesan
        messageType: {
            image: '[Gambar]',
            gifAnimation: '[GIF]',
            audio: '[Audio]',
            touch3d: '[3D Touch]',
            card: '[Kartu]',
            tip: '[Tips]',
            soul: '[Jiwa]',
            media: '[Media]',
            mateIntro: '[Intro pasangan]',
            post: '[Postingan]',
            novel: '[Novel]',
            sceneSwitch: '[Adegan]',
        },
        
        // Terkait filter
        genderFilter: 'Jenis Kelamin',
        interestTags: 'Minat',
        resetFilter: 'Reset Filter',
        
        // Daftar chat
        messageList: 'Daftar Pesan',
        recentChats: 'Chat Terbaru',
        noMessages: 'Tidak ada pesan',
        noChatHistory: 'Tidak ada riwayat chat',
        noMoments: 'Tidak ada momen',
        continue: 'Lanjutkan',
        
        // Tab halaman detail
        profile: 'Profil',
        moments: 'Momen',
        characterIntro: '📝 Intro Karakter',
        characterProfile: '🌟 Profil Karakter',
        characterSetting: '🌟 Pengaturan Karakter',
        personality: '😇 Kepribadian',
        backgroundStory: '🏰 Cerita Latar',
        interests: '💖 Minat',
        likes: '💕 Suka',
        dislikes: '💔 Tidak Suka',
        expand: 'Perluas',
        collapse: 'Ciutkan',
        noIntro: 'Tidak ada intro',
        noMore: 'Tidak ada lagi',
        
        // Label info
        gender: 'Jenis Kelamin',
        age: 'Umur',
        height: 'Tinggi',
        weight: 'Berat',
        
        // Tag - untuk index.vue (format tagXXX)
        tagAll: 'SEMUA',
        tagStepRelative: 'Keluarga Tiri',
        tagRoommate: 'Teman Sekamar',
        tagNeighbor: 'Tetangga',
        tagMarried: 'Menikah',
        tagEx: 'Mantan',
        tagChildhoodSweetheart: 'Cinta Masa Kecil',
        tagBoss: 'Bos',
        tagSubordinate: 'Bawahan',
        tagTeacherStudent: 'Guru/Murid',
        tagArchEnemy: 'Musuh Bebuyutan',
        tagStranger: 'Orang Asing',
        tagContractPartner: 'Pasangan Kontrak',
        tagRichFamily: 'Keluarga Kaya',
        tagMafia: 'Mafia',
        tagDoctor: 'Dokter',
        tagIdol: 'Idol',
        tagAssassin: 'Pembunuh',
        tagMaid: 'Pelayan',
        tagLandlord: 'Pemilik Rumah',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Dingin',
        tagShy: 'Pemalu',
        tagDominant: 'Dominan',
        tagSubmissive: 'Patuh',
        tagGentle: 'Lembut',
        tagAirhead: 'Polos',
        tagStrict: 'Tegas',
        tagObsessed: 'Terobsesi',
        tagScheming: 'Licik',
        tagPureLove: 'Cinta Murni',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Berisi',
        tagMuscular: 'Berotot',
        tagPetite: 'Mungil',
        tagGothic: 'Gothic',
        tagHotGirl: 'Gadis Seksi',
        tagUniform: 'Seragam',
        tagVampire: 'Vampir',
        tagWerewolf: 'Manusia Serigala',
        tagDemon: 'Iblis',
        tagSuccubus: 'Succubus',
        tagOrc: 'Orc',
        tagMonsterGirl: 'Gadis Monster',
        tagRobot: 'Robot',
        tagElf: 'Peri',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'Tempat Kerja',
        tagSchool: 'Sekolah',
        tagFantasy: 'Fantasi',
        tagUrban: 'Urban',
        tagBlindDate: 'Kencan Buta',
        tagDark: 'Gelap',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Tag
        tags: {
            ALL: 'SEMUA',
            STEP_RELATIVE: 'Keluarga Tiri',
            ROOMMATE: 'Teman Sekamar',
            NEIGHBOR: 'Tetangga',
            MARRIED: 'Menikah',
            EX: 'Mantan',
            CHILDHOOD_SWEETHEART: 'Cinta Masa Kecil',
            BOSS: 'Bos',
            SUBORDINATE: 'Bawahan',
            TEACHER_STUDENT: 'Guru/Murid',
            ARCH_ENEMY: 'Musuh Bebuyutan',
            STRANGER: 'Orang Asing',
            CONTRACT_PARTNER: 'Pasangan Kontrak',
            RICH_FAMILY: 'Keluarga Kaya',
            MAFIA: 'Mafia',
            DOCTOR: 'Dokter',
            IDOL: 'Idol',
            ASSASSIN: 'Pembunuh',
            MAID: 'Pelayan',
            LANDLORD: 'Pemilik Rumah',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Dingin',
            SHY: 'Pemalu',
            DOMINANT: 'Dominan',
            SUBMISSIVE: 'Patuh',
            GENTLE: 'Lembut',
            AIRHEAD: 'Polos',
            STRICT: 'Tegas',
            OBSESSED: 'Terobsesi',
            SCHEMING: 'Licik',
            PURE_LOVE: 'Cinta Murni',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Berisi',
            MUSCULAR: 'Berotot',
            PETITE: 'Mungil',
            GOTHIC: 'Gothic',
            HOT_GIRL: 'Gadis Seksi',
            UNIFORM: 'Seragam',
            VAMPIRE: 'Vampir',
            WEREWOLF: 'Manusia Serigala',
            DEMON: 'Iblis',
            SUCCUBUS: 'Succubus',
            ORC: 'Orc',
            MONSTER_GIRL: 'Gadis Monster',
            ROBOT: 'Robot',
            ELF: 'Peri',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'Tempat Kerja',
            SCHOOL: 'Sekolah',
            FANTASY: 'Fantasi',
            URBAN: 'Urban',
            BLIND_DATE: 'Kencan Buta',
            DARK: 'Gelap',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    tr: {
        // Liste sayfası temel UI
        loading: 'Yükleniyor',
        pleaseWait: 'Lütfen bekleyin...',
        filter: 'Filtre',
        recommend: 'Önerilen',
        latest: 'En yeni',
        male: 'Erkek',
        female: 'Kadın',
        recent: 'Son',
        
        // Boş durumlar
        noCharactersFound: 'Karakter bulunamadı',
        adjustFilters: 'Filtrelerinizi ayarlamayı deneyin',
        adjustFiltersSuggestion: 'veya diğer kategorilere göz atın',
        resetAll: 'Tümünü sıfırla',
        noDescription: 'Açıklama yok',
        
        // Eylemler
        startChat: 'Sohbeti başlat',
        chat: 'Sohbet',
        // Yükleme durumları
        loadFailed: 'Yükleme başarısız',
        noMoreData: 'Daha fazla veri yok',
        
        // Toast mesajları
        toast: {
            operationFailed: 'İşlem başarısız',
        },
        
        // Zaman biçimlendirme
        time: {
            justNow: 'Az önce',
            minutesAgo: 'dk önce',
            hoursAgo: 'saat önce',
            yesterday: 'Dün',
        },
        
        // Mesaj türleri
        messageType: {
            image: '[Resim]',
            gifAnimation: '[GIF]',
            audio: '[Ses]',
            touch3d: '[3D Dokunuş]',
            card: '[Kart]',
            tip: '[İpucu]',
            soul: '[Ruh]',
            media: '[Medya]',
            mateIntro: '[Partner tanıtımı]',
            post: '[Gönderi]',
            novel: '[Roman]',
            sceneSwitch: '[Sahne]',
        },
        
        // Filtre ile ilgili
        genderFilter: 'Cinsiyet',
        interestTags: 'İlgi Alanları',
        resetFilter: 'Filtreyi Sıfırla',
        
        // Sohbet listesi
        messageList: 'Mesaj Listesi',
        recentChats: 'Son Sohbetler',
        noMessages: 'Mesaj yok',
        noChatHistory: 'Sohbet geçmişi yok',
        noMoments: 'Anı yok',
        continue: 'Devam',
        
        // Detay sayfası sekmeleri
        profile: 'Profil',
        moments: 'Anılar',
        characterIntro: '📝 Karakter Tanıtımı',
        characterProfile: '🌟 Karakter Profili',
        characterSetting: '🌟 Karakter Ayarı',
        personality: '😇 Kişilik',
        backgroundStory: '🏰 Arka Plan Hikayesi',
        interests: '💖 İlgi Alanları',
        likes: '💕 Sevdikleri',
        dislikes: '💔 Sevmedikleri',
        expand: 'Genişlet',
        collapse: 'Daralt',
        noIntro: 'Tanıtım yok',
        noMore: 'Daha fazla yok',
        
        // Bilgi etiketleri
        gender: 'Cinsiyet',
        age: 'Yaş',
        height: 'Boy',
        weight: 'Kilo',
        
        // Etiketler - index.vue için (tagXXX formatı)
        tagAll: 'TÜMÜ',
        tagStepRelative: 'Üvey Akraba',
        tagRoommate: 'Oda Arkadaşı',
        tagNeighbor: 'Komşu',
        tagMarried: 'Evli',
        tagEx: 'Eski',
        tagChildhoodSweetheart: 'Çocukluk Aşkı',
        tagBoss: 'Patron',
        tagSubordinate: 'Ast',
        tagTeacherStudent: 'Öğretmen/Öğrenci',
        tagArchEnemy: 'Ezeli Düşman',
        tagStranger: 'Yabancı',
        tagContractPartner: 'Sözleşmeli Partner',
        tagRichFamily: 'Zengin Aile',
        tagMafia: 'Mafya',
        tagDoctor: 'Doktor',
        tagIdol: 'İdol',
        tagAssassin: 'Suikastçı',
        tagMaid: 'Hizmetçi',
        tagLandlord: 'Ev Sahibi',
        tagYandere: 'Yandere',
        tagTsundere: 'Tsundere',
        tagAloof: 'Mesafeli',
        tagShy: 'Utangaç',
        tagDominant: 'Baskın',
        tagSubmissive: 'İtaatkar',
        tagGentle: 'Nazik',
        tagAirhead: 'Dalgın',
        tagStrict: 'Sert',
        tagObsessed: 'Takıntılı',
        tagScheming: 'Entrikacı',
        tagPureLove: 'Saf Aşk',
        tagMilf: 'MILF',
        tagDilf: 'DILF',
        tagCurvy: 'Dolgun',
        tagMuscular: 'Kaslı',
        tagPetite: 'Minyon',
        tagGothic: 'Gotik',
        tagHotGirl: 'Seksi Kız',
        tagUniform: 'Üniforma',
        tagVampire: 'Vampir',
        tagWerewolf: 'Kurt Adam',
        tagDemon: 'İblis',
        tagSuccubus: 'Succubus',
        tagOrc: 'Ork',
        tagMonsterGirl: 'Canavar Kız',
        tagRobot: 'Robot',
        tagElf: 'Elf',
        tagDoujin: 'Doujin',
        tagAnime: 'Anime',
        tagTwoDimensional: '2D',
        tagWorkplace: 'İş Yeri',
        tagSchool: 'Okul',
        tagFantasy: 'Fantezi',
        tagUrban: 'Şehir',
        tagBlindDate: 'Görücü Usulü',
        tagDark: 'Karanlık',
        tagBoysLove: 'BL',
        tagGirlsLove: 'GL',
        tagLgbt: 'LGBT',
        tagNsfw: 'NSFW',
        
        // Etiketler
        tags: {
            ALL: 'TÜMÜ',
            STEP_RELATIVE: 'Üvey Akraba',
            ROOMMATE: 'Oda Arkadaşı',
            NEIGHBOR: 'Komşu',
            MARRIED: 'Evli',
            EX: 'Eski',
            CHILDHOOD_SWEETHEART: 'Çocukluk Aşkı',
            BOSS: 'Patron',
            SUBORDINATE: 'Ast',
            TEACHER_STUDENT: 'Öğretmen/Öğrenci',
            ARCH_ENEMY: 'Ezeli Düşman',
            STRANGER: 'Yabancı',
            CONTRACT_PARTNER: 'Sözleşmeli Partner',
            RICH_FAMILY: 'Zengin Aile',
            MAFIA: 'Mafya',
            DOCTOR: 'Doktor',
            IDOL: 'İdol',
            ASSASSIN: 'Suikastçı',
            MAID: 'Hizmetçi',
            LANDLORD: 'Ev Sahibi',
            YANDERE: 'Yandere',
            TSUNDERE: 'Tsundere',
            ALOOF: 'Mesafeli',
            SHY: 'Utangaç',
            DOMINANT: 'Baskın',
            SUBMISSIVE: 'İtaatkar',
            GENTLE: 'Nazik',
            AIRHEAD: 'Dalgın',
            STRICT: 'Sert',
            OBSESSED: 'Takıntılı',
            SCHEMING: 'Entrikacı',
            PURE_LOVE: 'Saf Aşk',
            MILF: 'MILF',
            DILF: 'DILF',
            CURVY: 'Dolgun',
            MUSCULAR: 'Kaslı',
            PETITE: 'Minyon',
            GOTHIC: 'Gotik',
            HOT_GIRL: 'Seksi Kız',
            UNIFORM: 'Üniforma',
            VAMPIRE: 'Vampir',
            WEREWOLF: 'Kurt Adam',
            DEMON: 'İblis',
            SUCCUBUS: 'Succubus',
            ORC: 'Ork',
            MONSTER_GIRL: 'Canavar Kız',
            ROBOT: 'Robot',
            ELF: 'Elf',
            DOUJIN: 'Doujin',
            ANIME: 'Anime',
            TWO_DIMENSIONAL: '2D',
            WORKPLACE: 'İş Yeri',
            SCHOOL: 'Okul',
            FANTASY: 'Fantezi',
            URBAN: 'Şehir',
            BLIND_DATE: 'Görücü Usulü',
            DARK: 'Karanlık',
            BOYS_LOVE: 'BL',
            GIRLS_LOVE: 'GL',
            LGBT: 'LGBT',
            NSFW: 'NSFW',
        },
    },
    }
